(function redirectToUs() {
  if (readCookie('_shopify_country')) {
    var isUserFromUS = readCookie('_shopify_country').replace('%2B', ' ') === 'United States';
  }
  
  if (isUserFromUS && !~window.location.href.indexOf('us.vincentdamerique.com')) {
    window.location.href = 'https://us.vincentdamerique.com';
  }
})();

window.theme = window.theme || {};

/* ================ SLATE ================ */
window.theme = window.theme || {};

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (_.isUndefined(constructor)) {
      return;
    }

    var instance = _.assignIn(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    this.instances = _.filter(this.instances, function(instance) {
      var isEventInstance = instance.id === evt.detail.sectionId;

      if (isEventInstance) {
        if (_.isFunction(instance.onUnload)) {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(
      function(index, container) {
        this._createInstance(container, constructor);
      }.bind(this)
    );
  }
});

window.slate = window.slate || {};

/**
 * Slate utilities
 * -----------------------------------------------------------------------------
 * A collection of useful utilities to help build your theme
 *
 *
 * @namespace utils
 */

slate.utils = {
  /**
   * Get the query params in a Url
   * Ex
   * https://mysite.com/search?q=noodles&b
   * getParameterByName('q') = "noodles"
   * getParameterByName('b') = "" (empty value)
   * getParameterByName('test') = null (absent)
   */
  getParameterByName: function(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  },

  keyboardKeys: {
    TAB: 9,
    ENTER: 13,
    LEFTARROW: 37,
    RIGHTARROW: 39
  },

  spacesTo_: function(string) {
    return string && string.replace(/\s/g, '_')
  }
};

window.slate = window.slate || {};

/**
 * iFrames
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace iframes
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    options.$tables.wrap(
      '<div class="' + options.tableWrapperClass + '"></div>'
    );
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + options.iframeWrapperClass + '"></div>');

      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

window.slate = window.slate || {};

/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {
  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element
      .first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element
        .first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on(
      'click',
      function(evt) {
        this.pageLinkFocus($(evt.currentTarget.hash));
      }.bind(this)
    );
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventsName = {
      focusin: options.namespace ? 'focusin.' + options.namespace : 'focusin',
      focusout: options.namespace
        ? 'focusout.' + options.namespace
        : 'focusout',
      keydown: options.namespace
        ? 'keydown.' + options.namespace
        : 'keydown.handleFocus'
    };

    /**
     * Get every possible visible focusable element
     */
    var $focusableElements = options.$container.find(
      $(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])'
      ).filter(':visible')
    );
    var firstFocusable = $focusableElements[0];
    var lastFocusable = $focusableElements[$focusableElements.length - 1];

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    function _manageFocus(evt) {
      if (evt.keyCode !== slate.utils.keyboardKeys.TAB) return;

      /**
       * On the last focusable element and tab forward,
       * focus the first element.
       */
      if (evt.target === lastFocusable && !evt.shiftKey) {
        evt.preventDefault();
        firstFocusable.focus();
      }
      /**
       * On the first focusable element and tab backward,
       * focus the last element.
       */
      if (evt.target === firstFocusable && evt.shiftKey) {
        evt.preventDefault();
        lastFocusable.focus();
      }
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).off('focusin');

    $(document).on(eventsName.focusout, function() {
      $(document).off(eventsName.keydown);
    });

    $(document).on(eventsName.focusin, function(evt) {
      if (evt.target !== lastFocusable && evt.target !== firstFocusable) return;

      $(document).on(eventsName.keydown, function(evt) {
        _manageFocus(evt);
      });
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  },

  /**
   * Add aria-describedby attribute to external and new window links
   *
   * @param {object} options - Options to be used
   * @param {object} options.messages - Custom messages to be used
   * @param {jQuery} options.$links - Specific links to be targeted
   */
  accessibleLinks: function(options) {
    var body = document.querySelector('body');

    var idSelectors = {
      newWindow: 'a11y-new-window-message',
      external: 'a11y-external-message',
      newWindowExternal: 'a11y-new-window-external-message'
    };

    if (options.$links === undefined || !options.$links.jquery) {
      options.$links = $('a[href]:not([aria-describedby])');
    }

    function generateHTML(customMessages) {
      if (typeof customMessages !== 'object') {
        customMessages = {};
      }

      var messages = $.extend(
        {
          newWindow: 'Opens in a new window.',
          external: 'Opens external website.',
          newWindowExternal: 'Opens external website in a new window.'
        },
        customMessages
      );

      var container = document.createElement('ul');
      var htmlMessages = '';

      for (var message in messages) {
        htmlMessages +=
          '<li id=' + idSelectors[message] + '>' + messages[message] + '</li>';
      }

      container.setAttribute('hidden', true);
      container.innerHTML = htmlMessages;

      body.appendChild(container);
    }

    function _externalSite($link) {
      var hostname = window.location.hostname;

      return $link[0].hostname !== hostname;
    }

    $.each(options.$links, function() {
      var $link = $(this);
      var target = $link.attr('target');
      var rel = $link.attr('rel');
      var isExternal = _externalSite($link);
      var isTargetBlank = target === '_blank';

      if (isExternal) {
        $link.attr('aria-describedby', idSelectors.external);
      }
      if (isTargetBlank) {
        if (rel === undefined || rel.indexOf('noopener') === -1) {
          $link.attr('rel', function(i, val) {
            var relValue = val === undefined ? '' : val + ' ';
            return relValue + 'noopener';
          });
        }
        $link.attr('aria-describedby', idSelectors.newWindow);
      }
      if (isExternal && isTargetBlank) {
        $link.attr('aria-describedby', idSelectors.newWindowExternal);
      }
    });

    generateHTML(options.messages);
  }
};

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

theme.Images = (function() {
  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Swaps the src of an image for another OR returns the imageURL to the callback function
   * @param image
   * @param element
   * @param callback
   */
  function switchImage(image, element, callback) {
    var size = this.imageSize(element.src);
    var imageUrl = this.getSizedImageUrl(image.src, size);

    if (callback) {
      callback(imageUrl, image, element); // eslint-disable-line callback-return
    } else {
      element.src = imageUrl;
    }
  }

  /**
   * +++ Useful
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(
      /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\\.@]/
    );

    if (match !== null) {
      if (match[2] !== undefined) {
        return match[1] + match[2];
      } else {
        return match[1];
      }
    } else {
      return null;
    }
  }

  /**
   * +++ Useful
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(
      /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
    );

    if (match !== null) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    }

    return null;
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    switchImage: switchImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 * Alternatives
 * - Accounting.js - http://openexchangerates.github.io/accounting.js/
 *
 */

theme.Currency = (function() {
  var moneyFormat = '${{amount}}'; // eslint-disable-line camelcase

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number === null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        '$1' + thousands
      );
      var centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist.  Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {
  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    var self = this;
    var mediaQuerySmall = 'screen and (max-width: 749px)';
    var mediaQueryMediumUp = 'screen and (min-width: 750px)';
    var $container = this.$container = options.$container;
    this.product = options.product;
    this.namespace = options.namespace;
    this.isDisplayingSwatches = options.displaySwatches;
    this.singleOptionSelector = options.singleOptionSelector;
    this.selectedVariantSelector = '.swatch--variant.swatch--selected'
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();
    this.swatchSelector = '.swatch--variant';
    this._updateMoreViewsFilter(this.currentVariant)

    // Swatches are, by default, only visible on desktop
    if (this.isDisplayingSwatches !== true && this.isDisplayingSwatches !== false) {
      enquire
        .register(mediaQuerySmall, { 
          match: function() {
            self.isDisplayingSwatches = false;
          }
        })
        .register(mediaQueryMediumUp, { 
          match: function() {
            self.isDisplayingSwatches = true;
          }
        });
    }

    $(this.singleOptionSelector, this.$container).on(
      'change',
      function() {
        if ($(this).attr('data-index') == 'option1') {
          self._updateSizeAvailability($('.single-option-selector[data-index="option1"]', $container).val())
        }

        self._onSelectChange()
      }
    );

    $(this.swatchSelector, this.$container).on(
      'click',
      this._onSwatchClick.bind(this)
    )
  }

  Variants.prototype = _.assignIn({}, Variants.prototype, {
    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      if (this.isDisplayingSwatches) {
        var currentOptions = _.map(
          $(this.selectedVariantSelector, this.$container),
          function(element) {
            var $element = $(element);
            return {
              index: $element.data('index'),
              value: $element.data('value')
            };
          }
        );
      } else {
        var currentOptions = _.map(
          $(this.singleOptionSelector, this.$container),
          function(element) {
            var $element = $(element);
            var type = $element.attr('type');
            var currentOption = {};

            if (type === 'radio' || type === 'checkbox') {
              if ($element[0].checked) {
                currentOption.value = $element.val();
                currentOption.index = $element.data('index');

                return currentOption;
              } else {
                return false;
              }
            } else {
              currentOption.value = $element.val();
              currentOption.index = $element.data('index');

              return currentOption;
            }
          }
        );
      }

      // remove any unselected values
      currentOptions = _.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;

      var found = _.find(variants, function(variant) {
        return selectedValues.every(function(values) {
          return _.isEqual(slate.utils.spacesTo_(variant[values.index]), slate.utils.spacesTo_(values.value));
        });
      });

      return found;
    },

    /**
    * Event handler for when a variant color changes.
    */
    _updateSizeAvailability: function(selectedColor) { 
      var $container = this.$container;     
      var $sizeSelector = $('.single-option-selector[data-index="option2"]', $container);
      var selectedSize = $sizeSelector.val();

      var variantsForColor = _.filter(this.product.variants, function(variant) {
        return variant.option1 === selectedColor;
      });

      // Disable all sizes
      $('option', $sizeSelector).attr('disabled', 'disabled').attr('hidden', 'hidden');
      $('.swatch[data-index="option2"]', $container).addClass('swatch--disabled').removeClass('swatch--selected')

      // Enable sizes that are available in each color
      $.each(variantsForColor, function(index, variant) {
        var sizeSwatch = $('.swatch[data-value="' + variant.option2 + '"]', $container);
        var sizeOption = $('option[value="' + variant.option2 + '"]', $container);

        if (variant.available) {          
          sizeSwatch.removeClass('swatch--disabled');
          sizeOption.attr('disabled', false);
          sizeOption.attr('hidden', false);          
        } else {        
          // unselect size if it is not available in new color
          if (variant.option2 === selectedSize) {
            $sizeSelector.prop("selectedIndex", 0);
          }
        }
      });
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();  
      this._updateVariant(variant);
    },

    /**
     * Event handler for when a variant swatch is clicked.
     */
    _onSwatchClick: function(evt) {
      var $swatch = $(evt.delegateTarget);
      if ($swatch.hasClass('swatch--disabled')) {        
        return;
      }

      this.selectSwatch($swatch);

      var variant = this._getVariantFromSwatches();
      this._updateVariant(variant);
    },

    selectSwatch($swatch) {
      $swatch.siblings().removeClass('swatch--selected');
      $swatch.addClass('swatch--selected');

      if ($swatch.data('index') == 'option1') {
        this._updateSizeAvailability($swatch.data('value'));
      }
    },

    _getVariantFromSwatches: function() {
      var selectedValues = _.reduce(
        $(this.selectedVariantSelector, this.$container), 
        function(acc, element) {
          return acc.concat($(element).data('value'));
        }, []
      );
      var variants = this.product.variants;

      var found = _.find(variants, function(variant) {
        if (variant.options.length > selectedValues.length) { 
          return; 
        }

        return variant.options.every(function(option, i) {
          return isEqualUnstrict(selectedValues[i], option)
        });

        /*
        * Use unstrict equality because the variant option can be 
        * number, while swatch value is string
        */ 
        function isEqualUnstrict(a, b) {
          return a == b;
        }
      });

      return found;
    },

    _updateVariant: function(variant) {
      var variantChange = this.namespace ? 'variantChange.' + this.namespace : 'variantChange';
      this.$container.trigger({
        type: variantChange,
        variant: variant
      });    

      this._updateMoreViewsFilter(variant);
      if (!variant) {
        return;
      }  

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this._updateSKU(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     */
    _updateMoreViewsFilter: function(variant) {
      var newColor = '';

      if (variant) {
        newColor = variant.option1;
      } else {
        var options = this._getCurrentOptions();
        newColor = options[0].value;
      }

      var new_color = slate.utils.spacesTo_(newColor)
      var $productThumbsWrapper = $('.js.thumbnails-wrapper', this.$container)
      $productThumbsWrapper.attr('color', new_color);

      // Show the thumbnails associated to current options
      $('.product-single__thumbnails-item', $productThumbsWrapper).hide();
      var $availableImages = $('.product-single__thumbnails-item.co-' + new_color, $productThumbsWrapper);
      $availableImages.show();

      // Set the featured image associated to current options
      $colorImages = $('.co-' + new_color, this.$container);
      if ($colorImages.length > 0) {
        var $newFeaturedImage = $colorImages.first();
        var imageId = $newFeaturedImage.find('[data-thumbnail-id]').data('thumbnail-id');

        // If there is no thumbnail, data should be on the image itself
        imageId = imageId || $newFeaturedImage.data('image-id');
        var imageChange = this.namespace ? 'variantImageChange.' + this.namespace : 'variantImageChange';

        this.$container.trigger({
          type: imageChange,
          variant: variant,
          image_id: imageId
        });
      }

      // Add slickfilter to co- + new_color
      var variantColorFilter = '.slick-js__slide.slick-co-' + new_color
      $('.slick-js.slick-initialized').slick('slickUnfilter').slick('slickFilter', variantColorFilter)
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = {}
      if (this.currentVariant) {
        currentVariantImage = this.currentVariant.featured_image || {};
      }

      var new_color = slate.utils.spacesTo_(variant.option1);
      var featured_image = $('.product-single__thumbnails-item.co-' + new_color, this.$container).data('thumbnail-id')

      if (
        !featured_image ||
        variantImage.src === currentVariantImage.src
      ) {
        return;
      }
      
      var imageChange = this.namespace ? 'variantImageChange.' + this.namespace : 'variantImageChange';
      this.$container.trigger({
        type: imageChange,
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      var currentPrice = -1;
      var currentCompareAt = -1;
      if (this.currentVariant && this.currentVariant.price) {
        currentPrice = this.currentVariant.price;
        currentCompareAt = this.currentVariant.compare_at_price;
      } else {
        currentPrice = variant.price;
        currentCompareAt = variant.compare_at_price;
      }

      if (
        variant.price === currentPrice &&
        variant.compare_at_price === currentCompareAt
      ) {
        return;
      }

      var priceChange = this.namespace ? 'variantPriceChange.' + this.namespace : 'variantPriceChange';
      this.$container.trigger({
        type: priceChange,
        variant: variant
      });
    },

    /**
     * Trigger event when variant sku changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantSKUChange
     */
    _updateSKU: function(variant) {
      if (this.currentVariant && (variant.sku === this.currentVariant.sku) ) {
        return;
      }

      var skuChange = this.namespace ? 'variantSKUChange.' + this.namespace : 'variantSKUChange';
      this.$container.trigger({
        type: skuChange,
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl =
        window.location.protocol +
        '//' +
        window.location.host +
        window.location.pathname +
        '?variant=' +
        variant.id;
      window.history.replaceState({ path: newurl }, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container).val(variant.id);
    }
  });

  return Variants;
})();

slate.stickElement = function (elements) {
  var headerHeight = elements.headerHeight || 41;
  var element = elements.element
  var elementContainer = elements.container
  var topSection = elements.topSection
  var bottomSection = elements.bottomSection

  // The container must take at least the same size in page as the fixed element
  elementContainer.setAttribute('style', 'height: ' + Math.max(element.offsetHeight, elementContainer.offsetHeight) + 'px')

  topSection.offsetBottom = ($(topSection).offset().top) + topSection.offsetHeight
  var stickyTopPosition = topSection.offsetBottom;
  var stickStart = ($(elementContainer).offset().top) - topSection.offsetBottom
  var stickEnd = bottomSection && (($(bottomSection).offset().top) - element.offsetHeight - topSection.offsetBottom)
  var stickyBottomPosition = bottomSection && (($(bottomSection).offset().top) - ($(elementContainer).offset().top) - element.offsetHeight + headerHeight)

  // Stick to bottom of page if element overflows
  if (element.offsetHeight > window.innerHeight - topSection.offsetBottom) {
    stickStart = ($(elementContainer).offset().top) + element.offsetHeight - window.innerHeight
    stickEnd = bottomSection && (($(bottomSection).offset().top) - window.innerHeight)
    stickyTopPosition = window.innerHeight - element.offsetHeight
  }

  // Function to execute on page scroll
  var updateSticky = function () {
    var viewY = window.pageYOffset

    // Stick to bottom, stick to top or unstick
    if (stickEnd && viewY >= stickEnd) {
      element.classList.add('stuck');
      element.setAttribute('style', 'position: absolute; top: ' + stickyBottomPosition + 'px')
    } else if (viewY >= stickStart) {
      element.classList.add('stuck');
      element.setAttribute('style', 'position: fixed; top: ' + stickyTopPosition + 'px')
    } else {
      element.classList.remove('stuck');
      element.removeAttribute('style')
    }
  }

  updateSticky()
  return updateSticky
}

slate.stickToTop = function(element) {
  var stickStart = $(element).offset().top

  var updateSticky = function() {
    var viewY = window.pageYOffset;

    if (viewY >= stickStart) {
      element.classList.remove('stuck');
      element.setAttribute('style', 'position: fixed; top: 0');
    } else {
      element.classList.remove('stuck');
      element.removeAttribute('style');
    }
  }

  updateSticky()
  return updateSticky
}

theme.NotificationPopup = (function() {
  var selectors = {
    typePrefix: '.js-popup-',
    close: '.js-close-popup',
    text: '.js-popup-text'
  };

  var classes = {
    active: 'active',
    activeHide: 'active--hide'
  };

  function NotificationPopup(type, text) {
    var selector = selectors.typePrefix + type
    var $popup = $(selector);

    if (!$popup.length) {
      return console.error('No popup found using selector: ' + selector);
    }

    this.$popup = $popup;
    this._setupClose();
    this._setText(text)
  }

  NotificationPopup.prototype._setText = function(text) {
    if (!this.$popup) {
      return;
    }

    this.$popup.find(selectors.text).text(text);
  };

  NotificationPopup.prototype._setupClose = function() {
    $(selectors.close).on('click', 
      this.hide.bind(this)
    );
  };

  NotificationPopup.prototype.show = function() {
    if (!this.$popup) {
      return;
    }

    this.$popup.removeClass(classes.active);
    clearTimeout(window.notificationHideTimeout);

    // Re-add the active class in a different runloop to reset the max-height transition
    var self = this;
    setTimeout(function() {
      self.$popup.addClass(classes.active);    
      self.$popup.removeClass(classes.activeHide);
      window.notificationHideTimeout = setTimeout(self.hide.bind(self), 4000);
    }, 1);    
  };

  NotificationPopup.prototype.hide = function() {
    if (!this.$popup) {
      return;
    }

    this.$popup.addClass(classes.activeHide)
  };  

  return NotificationPopup;
})();


/* ================ GLOBAL ================ */
/*============================================================================
  Drawer modules
==============================================================================*/
theme.Drawers = (function() {
  function Drawer(id, position, options) {
    var defaults = {
      close: '.js-drawer-close',
      open: '.js-drawer-open-' + position,
      openClass: 'js-drawer-open',
      dirOpenClass: 'js-drawer-open-' + position
    };

    this.nodes = {
      $parent: $('html').add('body'),
      $page: $('#PageContainer')
    };

    this.config = $.extend(defaults, options);
    this.position = position;

    this.$drawer = $('#' + id);

    if (!this.$drawer.length) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  }

  Drawer.prototype.init = function() {
    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$drawer.on('click', this.config.close, $.proxy(this.close, this));
  };

  Drawer.prototype.open = function(evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the drawer opens, the click event bubbles up to nodes.$page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    this.$drawer.prepareTransition();

    this.nodes.$parent.addClass(
      this.config.openClass + ' ' + this.config.dirOpenClass
    );
    this.drawerIsOpen = true;

    // Set focus on drawer
    slate.a11y.trapFocus({
      $container: this.$drawer,
      namespace: 'drawer_focus'
    });

    // Run function when draw opens if set
    if (
      this.config.onDrawerOpen &&
      typeof this.config.onDrawerOpen === 'function'
    ) {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    this.bindEvents();

    return this;
  };

  Drawer.prototype.close = function() {
    if (!this.drawerIsOpen) {
      // don't close a closed drawer
      return;
    }

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    // Ensure closing transition is applied to moved elements, like the nav
    this.$drawer.prepareTransition();

    this.nodes.$parent.removeClass(
      this.config.dirOpenClass + ' ' + this.config.openClass
    );

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'false');
    }

    this.drawerIsOpen = false;

    // Remove focus on drawer
    slate.a11y.removeTrapFocus({
      $container: this.$drawer,
      namespace: 'drawer_focus'
    });

    this.unbindEvents();

    // Run function when draw closes if set
    if (
      this.config.onDrawerClose &&
      typeof this.config.onDrawerClose === 'function'
    ) {
      this.config.onDrawerClose();
    }
  };

  Drawer.prototype.bindEvents = function() {
    this.nodes.$parent.on(
      'keyup.drawer',
      $.proxy(function(evt) {
        // close on 'esc' keypress
        if (evt.keyCode === 27) {
          this.close();
          return false;
        } else {
          return true;
        }
      }, this)
    );

    // Lock scrolling on mobile
    this.nodes.$page.on('touchmove.drawer', function() {
      return false;
    });

    this.nodes.$page.on(
      'click.drawer',
      $.proxy(function() {
        this.close();
        return false;
      }, this)
    );
  };

  Drawer.prototype.unbindEvents = function() {
    this.nodes.$page.off('.drawer');
    this.nodes.$parent.off('.drawer');
  };

  return Drawer;
})();


function menuPosition() {
  setTimeout(function() {
    jQuery('#SiteNav .site-nav__dropdown').each(function() {
      topIndent = jQuery(this).parent().position().top + 10;
      itemHeight = jQuery(this).parent().height();
      jQuery(this).css('top', topIndent + itemHeight);
    });
  }, 200);
}



/* ================ MODULES ================ */
window.theme = window.theme || {};

theme.Header = (function() {
  var selectors = {
    body: 'body',
    header: '.site-header',
    multicurrencySelector: '[data-currency-selector]',
    navigation: '#AccessibleNav',
    siteNavHasDropdown: '.site-nav--has-dropdown',
    siteNavChildLinks: '.site-nav__child-link',
    siteNavActiveDropdown: '.site-nav--active-dropdown',
    siteNavLinkMain: '.site-nav__link--main',
    siteNavChildLink: '.site-nav__link--last'
  };

  var config = {
    activeClass: 'site-nav--active-dropdown',
    childLinkClass: 'site-nav__child-link'
  };

  var cache = {};

  function init() {
    cacheSelectors();

    cache.$parents.on('click.siteNav', function() {
      var $el = $(this);
      $el.hasClass(config.activeClass) ? hideDropdown($el) : showDropdown($el);
    });


    /* floating header */
    if (jQuery('body').hasClass('floating-header')) {
      var headerHeight = 69
      var headerOffset = $(selectors.header).offset().top

      jQuery(window).scroll(function() {
        if (window.innerWidth <= 749) {
          return;
        }
        positionFloatingHeader();
        menuPosition();

        if (jQuery(this).scrollTop() > 0) {
          jQuery('body').addClass('not-at-zero');
        } else {
          jQuery('body').removeClass('not-at-zero');
        }
      });

      function positionFloatingHeader(){
        if (jQuery(this).scrollTop() >=  (headerHeight + headerOffset)) {
          if (!jQuery('#shopify-section-header').hasClass('floating')) {
            jQuery('#shopify-section-header').addClass('floating');
          }
        }else{
          if (jQuery('#shopify-section-header').hasClass('floating')) {
            jQuery('#shopify-section-header').removeClass('floating');
          }
        }
      }
      positionFloatingHeader();
    }

    /* Fix mobile nav for when announcement is displayed */
    var updateNavbarSticky = slate.stickToTop(document.querySelector('.site-header__mobile-nav'))
    window.addEventListener('scroll', updateNavbarSticky);

    var updateCartSticky = slate.stickToTop(document.querySelector('.top-cart'));
    window.addEventListener('scroll', updateCartSticky);

    // check when we're leaving a dropdown and close the active dropdown
    $(selectors.siteNavChildLink).on('focusout.siteNav', function() {
      setTimeout(function() {
        if (
          $(document.activeElement).hasClass(config.childLinkClass) ||
          !cache.$activeDropdown.length
        ) {
          return;
        }

        hideDropdown(cache.$activeDropdown);
      });
    });

    // close dropdowns when on top level nav
    cache.$topLevel.on('focus.siteNav', function() {
      if (cache.$activeDropdown.length) {
        hideDropdown(cache.$activeDropdown);
      }
    });

    cache.$subMenuLinks.on('click.siteNav', function(evt) {
      // Prevent click on body from firing instead of link
      evt.stopImmediatePropagation();
    });

    $(selectors.multicurrencySelector).on('change', function() {
      $(this)
        .parents('form')
        .submit();
    });
  }

  function cacheSelectors() {
    cache = {
      $nav: $(selectors.navigation),
      $topLevel: $(selectors.siteNavLinkMain),
      $parents: $(selectors.navigation).find(selectors.siteNavHasDropdown),
      $subMenuLinks: $(selectors.siteNavChildLinks),
      $activeDropdown: $(selectors.siteNavActiveDropdown)
    };
  }

  function showDropdown($el) {
    $el.addClass(config.activeClass);
    // close open dropdowns
    if (cache.$activeDropdown.length) {
      hideDropdown(cache.$activeDropdown);
    }

    //if (cache.$activeDropdown)

    cache.$activeDropdown = $el;

    // set expanded on open dropdown
    $el.find(selectors.siteNavLinkMain).attr('aria-expanded', 'true');

    setTimeout(function() {
      $(window).on('keyup.siteNav', function(evt) {
        if (evt.keyCode === 27) {
          hideDropdown($el);
        }
      });
      $(selectors.body).on('click.siteNav', function() {
        hideDropdown($el);
      });
      // cache.$parents.on('click.siteNav', function() {
      //   hideDropdown($el);
      // })
    }, 250);
  }

  function hideDropdown($el) {
    // remove aria on open dropdown
    $el.find(selectors.siteNavLinkMain).attr('aria-expanded', 'false');
    $el.removeClass(config.activeClass);

    // reset active dropdown
    cache.$activeDropdown = $(selectors.siteNavActiveDropdown);

    $(selectors.body).off('click.siteNav');
    $(window).off('keyup.siteNav');
  }

  function unload() {
    $(window).off('.siteNav');
    cache.$parents.off('.siteNav');
    cache.$subMenuLinks.off('.siteNav');
    cache.$topLevel.off('.siteNav');
    $(selectors.siteNavChildLink).off('.siteNav');
    $(selectors.body).off('.siteNav');
  }

  return {
    init: init,
    unload: unload
  };
})();

window.theme = window.theme || {};

theme.MobileNav = (function() {
  var classes = {
    mobileNavOpenIcon: 'mobile-nav--open',
    mobileNavCloseIcon: 'mobile-nav--close',
    navLinkWrapper: 'mobile-nav__item',
    navLink: 'mobile-nav__link',
    subNavLink: 'mobile-nav__sublist-link',
    return: 'mobile-nav__return-btn',
    subNavActive: 'is-active',
    subNavClosing: 'is-closing',
    navOpen: 'js-menu--is-open',
    subNavShowing: 'sub-nav--is-open',
    thirdNavShowing: 'third-nav--is-open',
    subNavToggleBtn: 'js-toggle-submenu'
  };
  var cache = {};
  var isTransitioning;
  var $activeSubNav;
  var $activeTrigger;
  var menuLevel = 1;
  // Breakpoints from src/stylesheets/global/variables.scss.liquid
  var mediaQuerySmall = 'screen and (max-width: 749px)';

  function init() {
    cacheSelectors();

    cache.$mobileNavToggle.on('click', toggleMobileNav);
    cache.$subNavToggleBtn.on('click.subNav', toggleSubNav);

    // Close mobile nav when unmatching mobile breakpoint
    enquire.register(mediaQuerySmall, {
      unmatch: function() {
        if (cache.$mobileNavContainer.hasClass(classes.navOpen)) {
          closeMobileNav();
        }
      }
    });
  }

  function toggleMobileNav() {
    if (cache.$mobileNavToggle.hasClass(classes.mobileNavCloseIcon)) {
      closeMobileNav();
    } else {
      openMobileNav();
    }
  }

  function cacheSelectors() {
    cache = {
      $pageContainer: $('#PageContainer'),
      $siteHeader: $('.site-header'),
      $mobileNavToggle: $('.js-mobile-nav-toggle'),
      $mobileNavContainer: $('.mobile-nav-wrapper'),
      $mobileNav: $('#MobileNav'),
      $sectionHeader: $('#shopify-section-header'),
      $subNavToggleBtn: $('.' + classes.subNavToggleBtn)
    };
  }

  function openMobileNav() {
    var translateHeaderHeight = cache.$siteHeader.outerHeight();

    cache.$mobileNavContainer.addClass(classes.navOpen);

    cache.$mobileNavContainer.css({
      'z-index': 100000,
      'background': '#F1F1F1',
      'opacity': 0.97
    });

    slate.a11y.trapFocus({
      $container: cache.$sectionHeader,
      $elementToFocus: cache.$mobileNavToggle,
      namespace: 'navFocus'
    });

    cache.$mobileNavToggle
      .addClass(classes.mobileNavCloseIcon)
      .removeClass(classes.mobileNavOpenIcon)
      .attr('aria-expanded', true);

    // close on escape
    $(window).on('keyup.mobileNav', function(evt) {
      if (evt.which === 27) {
        closeMobileNav();
      }
    });
  }

  function closeMobileNav() {
    cache.$mobileNavContainer.removeClass(classes.navOpen);

    cache.$mobileNavContainer.css({
      'z-index': 0,
      'opacity': 0
    });

    cache.$pageContainer.removeAttr('style');

    slate.a11y.trapFocus({
      $container: $('html'),
      $elementToFocus: $('body')
    });

    cache.$mobileNavContainer.one(
      'TransitionEnd.navToggle webkitTransitionEnd.navToggle transitionend.navToggle oTransitionEnd.navToggle',
      function() {
        slate.a11y.removeTrapFocus({
          $container: cache.$mobileNav,
          namespace: 'navFocus'
        });
      }
    );

    cache.$mobileNavToggle
      .addClass(classes.mobileNavOpenIcon)
      .removeClass(classes.mobileNavCloseIcon)
      .attr('aria-expanded', false)
      .focus();

    $(window).off('keyup.mobileNav');
  }

  function toggleSubNav(evt) {  
    var $toggleBtn = $(evt.currentTarget);

    if (evt.currentTarget.classList.contains('is-active')) {
      // Close all subnavs by removing active class on buttons
      $(
        '.' + classes.subNavToggleBtn + '[data-level="' + (menuLevel - 1) + '"]'
      ).removeClass(classes.subNavActive);

      if ($activeTrigger && $activeTrigger.length) {
        $activeTrigger.removeClass(classes.subNavActive);
      }
    } else {
      $(
        '.' + classes.subNavToggleBtn + '[data-level="' + (menuLevel - 1) + '"]'
      ).removeClass(classes.subNavActive);

      $toggleBtn.addClass(classes.subNavActive);
    }

    $activeTrigger = $toggleBtn;

    goToSubnav($toggleBtn.data('target'));
  }

  function goToSubnav(target) {
    /*eslint-disable shopify/jquery-dollar-sign-reference */

    var $targetMenu = target
      ? $('.mobile-nav__dropdown[data-parent="' + target + '"]')
      : cache.$mobileNav;

    menuLevel = $targetMenu.data('level') ? $targetMenu.data('level') : 1;

    if ($activeSubNav && $activeSubNav.length) {
      $activeSubNav.addClass(classes.subNavClosing);
    }

    $activeSubNav = $targetMenu;

    /*eslint-enable shopify/jquery-dollar-sign-reference */

    var translateMenuHeight = $targetMenu.outerHeight();

    var openNavClass =
      menuLevel > 2 ? classes.thirdNavShowing : classes.subNavShowing;

    cache.$mobileNavContainer
      //.css('height', translateMenuHeight)
      .removeClass(classes.thirdNavShowing)
      .addClass(openNavClass);

    if (!target) {
      // Show top level nav
      cache.$mobileNavContainer
        .removeClass(classes.thirdNavShowing)
        .removeClass(classes.subNavShowing);
    }

    /* if going back to first subnav, focus is on whole header */
    var $container = menuLevel === 1 ? cache.$sectionHeader : $targetMenu;

    var $menuTitle = $targetMenu.find('[data-menu-title=' + menuLevel + ']');
    var $elementToFocus = $menuTitle ? $menuTitle : $targetMenu;

    // Focusing an item in the subnav early forces element into view and breaks the animation.
    cache.$mobileNavContainer.one(
      'TransitionEnd.subnavToggle webkitTransitionEnd.subnavToggle transitionend.subnavToggle oTransitionEnd.subnavToggle',
      function() {
        slate.a11y.trapFocus({
          $container: $container,
          $elementToFocus: $elementToFocus,
          namespace: 'subNavFocus'
        });

        cache.$mobileNavContainer.off('.subnavToggle');
        isTransitioning = false;
      }
    );

    // Match height of subnav
    // cache.$pageContainer.css({
    //   transform: 'translateY(' + translateMenuHeight + 'px)'
    // });

    $activeSubNav.removeClass(classes.subNavClosing);
  }

  return {
    init: init,
    closeMobileNav: closeMobileNav
  };
})(jQuery);

window.theme = window.theme || {};

theme.Search = (function() {
  var selectors = {
    search: '.search',
    searchSubmit: '.search__submit',
    searchInput: '.search__input',

    siteHeader: '.site-header',
    siteHeaderSearchToggle: '.site-header__search-toggle',
    siteHeaderSearch: '.site-header__search',

    searchDrawer: '.search-bar',
    searchDrawerInput: '.search-bar__input',

    searchHeader: '.search-header',
    searchHeaderInput: '.search-header__input',
    searchHeaderSubmit: '.search-header__submit',

    searchResultSubmit: '#SearchResultSubmit',
    searchResultInput: '#SearchInput',
    searchResultMessage: '[data-search-error-message]',

    mobileNavWrapper: '.mobile-nav-wrapper'
  };

  var classes = {
    focus: 'search--focus',
    hidden: 'hide',
    mobileNavIsOpen: 'js-menu--is-open'
  };

  function init() {
    if (!$(selectors.siteHeader).length) {
      return;
    }

    this.$searchResultInput = $(selectors.searchResultInput);
    this.$searchErrorMessage = $(selectors.searchResultMessage);

    //initDrawer();

    var isSearchPage =
      slate.utils.getParameterByName('q') !== null &&
      window.location.pathname === '/search';

    if (isSearchPage) {
      validateSearchResultForm.call(this);
    }

    $(selectors.searchResultSubmit).on(
      'click',
      validateSearchResultForm.bind(this)
    );

    $(selectors.searchHeaderInput)
      .add(selectors.searchHeaderSubmit)
      .on('focus blur', function() {
        $(selectors.searchHeader).toggleClass(classes.focus);
      });

      /*
    $(selectors.siteHeaderSearchToggle).on('click', function() {
      var searchHeight = $(selectors.siteHeader).outerHeight();
      var searchOffset = $(selectors.siteHeader).offset().top - searchHeight;

      $(selectors.searchDrawer).css({
        height: searchHeight + 'px',
        top: searchOffset + 'px'
      });
    });*/
  }

  function initDrawer() {
    // Add required classes to HTML
    $('#PageContainer').addClass('drawer-page-content');
    $('.js-drawer-open-top')
      .attr('aria-controls', 'SearchDrawer')
      .attr('aria-expanded', 'false')
      .attr('aria-haspopup', 'dialog');

    theme.SearchDrawer = new theme.Drawers('SearchDrawer', 'top', {
      onDrawerOpen: searchDrawerFocus,
      onDrawerClose: searchDrawerFocusClose
    });
  }

  function searchDrawerFocus() {
    searchFocus($(selectors.searchDrawerInput));

    if ($(selectors.mobileNavWrapper).hasClass(classes.mobileNavIsOpen)) {
      theme.MobileNav.closeMobileNav();
    }
  }

  function searchFocus($el) {
    $el.focus();
    // set selection range hack for iOS
    $el[0].setSelectionRange(0, $el[0].value.length);
  }

  function searchDrawerFocusClose() {
    $(selectors.siteHeaderSearchToggle).focus();
  }

  /**
   * Remove the aria-attributes and hide the error messages
   */
  function hideErrorMessage() {
    this.$searchErrorMessage.addClass(classes.hidden);
    this.$searchResultInput
      .removeAttr('aria-describedby')
      .removeAttr('aria-invalid');
  }

  /**
   * Add the aria-attributes and show the error messages
   */
  function showErrorMessage() {
    this.$searchErrorMessage.removeClass(classes.hidden);
    this.$searchResultInput
      .attr('aria-describedby', 'error-search-form')
      .attr('aria-invalid', true);
  }

  function validateSearchResultForm(evt) {
    var isInputValueEmpty = this.$searchResultInput.val().trim().length === 0;

    if (!isInputValueEmpty) {
      hideErrorMessage.call(this);
      return;
    }

    if (typeof evt !== 'undefined') {
      evt.preventDefault();
    }

    searchFocus(this.$searchResultInput);
    showErrorMessage.call(this);
  }

  return {
    init: init
  };
})();

(function() {
  var selectors = {
    backButton: '.return-link'
  };

  var $backButton = $(selectors.backButton);

  if (!document.referrer || !$backButton.length || !window.history.length) {
    return;
  }

  $backButton.one('click', function(evt) {
    evt.preventDefault();

    var referrerDomain = urlDomain(document.referrer);
    var shopDomain = urlDomain(window.location.href);

    if (shopDomain === referrerDomain) {
      history.back();
    }

    return false;
  });

  function urlDomain(url) {
    var anchor = document.createElement('a');
    anchor.ref = url;

    return anchor.hostname;
  }
})();

theme.Slideshow = (function() {
  this.$slideshow = null;
  var classes = {
    slideshow: 'slideshow',
    slickActiveMobile: 'slick-active-mobile',
    controlsHover: 'slideshow__controls--hover',
    isPaused: 'is-paused'
  };

  var selectors = {
    section: '.shopify-section',
    wrapper: '#SlideshowWrapper-',
    slides: '.slideshow__slide',
    textWrapperMobile: '.slideshow__text-wrap--mobile',
    textContentMobile: '.slideshow__text-content--mobile',
    controls: '.slideshow__controls',
    pauseButton: '.slideshow__pause',
    dots: '.slick-dots',
    arrows: '.slideshow__arrows',
    arrowsMobile: '.slideshow__arrows--mobile',
    arrowLeft: '.slideshow__arrow-left',
    arrowRight: '.slideshow__arrow-right'
  };

  function slideshow(el, sectionId) {
    var $slideshow = (this.$slideshow = $(el));
    this.adaptHeight = this.$slideshow.data('adapt-height');
    this.$wrapper = this.$slideshow.closest(selectors.wrapper + sectionId);
    this.$section = this.$wrapper.closest(selectors.section);
    this.$controls = this.$wrapper.find(selectors.controls);
    this.$arrows = this.$section.find(selectors.arrows);
    this.$arrowsMobile = this.$section.find(selectors.arrowsMobile);
    this.$pause = this.$controls.find(selectors.pauseButton);
    this.$textWrapperMobile = this.$section.find(selectors.textWrapperMobile);
    this.autorotate = this.$slideshow.data('autorotate');
    var autoplaySpeed = this.$slideshow.data('speed');
    var loadSlideA11yString = this.$slideshow.data('slide-nav-a11y');

    this.settings = {
      accessibility: true,
      arrows: false,
      dots: true,
      fade: true,
      draggable: true,
      touchThreshold: 20,
      autoplay: this.autorotate,
      autoplaySpeed: autoplaySpeed,
      // eslint-disable-next-line shopify/jquery-dollar-sign-reference
      appendDots: this.$arrows,
      customPaging: function(slick, index) {
        return (
          '<a href="' +
          selectors.wrapper +
          sectionId +
          '" aria-label="' +
          loadSlideA11yString.replace('[slide_number]', index + 1) +
          '" data-slide-number="' +
          index +
          '"></a>'
        );
      }
    };

    this.$slideshow.on('beforeChange', beforeChange.bind(this));
    this.$slideshow.on('init', slideshowA11ySetup.bind(this));

    // Add class to style mobile dots & show the correct text content for the
    // first slide on mobile when the slideshow initialises
    this.$slideshow.on(
      'init',
      function() {
        this.$mobileDots
          .find('li:first-of-type')
          .addClass(classes.slickActiveMobile);
        this.showMobileText(0);
      }.bind(this)
    );

    // Stop the autorotate when you scroll past the mobile controls, resume when
    // they are scrolled back into view
    if (this.autorotate) {
      $(document).scroll(
        $.debounce(
          250,
          function() {
            if (
              this.$arrowsMobile.offset().top +
                this.$arrowsMobile.outerHeight() <
              window.pageYOffset
            ) {
              $slideshow.slick('slickPause');
            } else if (!this.$pause.hasClass(classes.isPaused)) {
              $slideshow.slick('slickPlay');
            }
          }.bind(this)
        )
      );
    }

    if (this.adaptHeight) {
      this.setSlideshowHeight();
      $(window).resize($.debounce(50, this.setSlideshowHeight.bind(this)));
    }

    this.$slideshow.slick(this.settings);

    // This can't be called when the slick 'init' event fires due to how slick
    // adds a11y features.
    slideshowPostInitA11ySetup.bind(this)();

    this.$arrows.find(selectors.arrowLeft).on('click', function() {
      $slideshow.slick('slickPrev');
    });
    this.$arrows.find(selectors.arrowRight).on('click', function() {
      $slideshow.slick('slickNext');
    });

    this.$pause.on('click', this.togglePause.bind(this));
  }

  function slideshowA11ySetup(event, obj) {
    var $slider = obj.$slider;
    var $list = obj.$list;
    this.$dots = this.$section.find(selectors.dots);
    this.$mobileDots = this.$dots.eq(1);

    // Remove default Slick aria-live attr until slider is focused
    $list.removeAttr('aria-live');

    this.$wrapper.on('keyup', keyboardNavigation.bind(this));
    this.$controls.on('keyup', keyboardNavigation.bind(this));
    this.$textWrapperMobile.on('keyup', keyboardNavigation.bind(this));

    // When an element in the slider is focused
    // pause slideshow and set aria-live.
    this.$wrapper
      .on(
        'focusin',
        function(evt) {
          if (!this.$wrapper.has(evt.target).length) {
            return;
          }

          $list.attr('aria-live', 'polite');
          if (this.autorotate) {
            $slider.slick('slickPause');
          }
        }.bind(this)
      )
      .on(
        'focusout',
        function(evt) {
          if (!this.$wrapper.has(evt.target).length) {
            return;
          }

          $list.removeAttr('aria-live');
          if (this.autorotate) {
            // Only resume playing if the user hasn't paused using the pause
            // button
            if (!this.$pause.is('.is-paused')) {
              $slider.slick('slickPlay');
            }
          }
        }.bind(this)
      );

    // Add arrow key support when focused
    if (this.$dots) {
      this.$dots
        .find('a')
        .each(function() {
          var $dot = $(this);
          $dot.on('click keyup', function(evt) {
            if (
              evt.type === 'keyup' &&
              evt.which !== slate.utils.keyboardKeys.ENTER
            )
              return;

            evt.preventDefault();

            var slideNumber = $(evt.target).data('slide-number');

            $slider.attr('tabindex', -1).slick('slickGoTo', slideNumber);

            if (evt.type === 'keyup') {
              $slider.focus();
            }
          });
        })
        .eq(0)
        .attr('aria-current', 'true');
    }

    this.$controls
      .on('focusin', highlightControls.bind(this))
      .on('focusout', unhighlightControls.bind(this));
  }

  function slideshowPostInitA11ySetup() {
    var $slides = this.$slideshow.find(selectors.slides);

    $slides.removeAttr('role').removeAttr('aria-labelledby');
    this.$dots
      .removeAttr('role')
      .find('li')
      .removeAttr('role')
      .removeAttr('aria-selected')
      .each(function() {
        var $dot = $(this);
        var ariaControls = $dot.attr('aria-controls');
        $dot
          .removeAttr('aria-controls')
          .find('a')
          .attr('aria-controls', ariaControls);
      });
  }

  function beforeChange(event, slick, currentSlide, nextSlide) {
    var $dotLinks = this.$dots.find('a');
    var $mobileDotLinks = this.$mobileDots.find('li');

    $dotLinks
      .removeAttr('aria-current')
      .eq(nextSlide)
      .attr('aria-current', 'true');

    $mobileDotLinks
      .removeClass(classes.slickActiveMobile)
      .eq(nextSlide)
      .addClass(classes.slickActiveMobile);
    this.showMobileText(nextSlide);
  }

  function keyboardNavigation() {
    if (event.keyCode === slate.utils.keyboardKeys.LEFTARROW) {
      this.$slideshow.slick('slickPrev');
    }
    if (event.keyCode === slate.utils.keyboardKeys.RIGHTARROW) {
      this.$slideshow.slick('slickNext');
    }
  }

  function highlightControls() {
    this.$controls.addClass(classes.controlsHover);
  }

  function unhighlightControls() {
    this.$controls.removeClass(classes.controlsHover);
  }

  slideshow.prototype.togglePause = function() {
    var slideshowSelector = getSlideshowId(this.$pause);
    if (this.$pause.hasClass(classes.isPaused)) {
      this.$pause.removeClass(classes.isPaused).attr('aria-pressed', 'false');
      if (this.autorotate) {
        $(slideshowSelector).slick('slickPlay');
      }
    } else {
      this.$pause.addClass(classes.isPaused).attr('aria-pressed', 'true');
      if (this.autorotate) {
        $(slideshowSelector).slick('slickPause');
      }
    }
  };

  slideshow.prototype.setSlideshowHeight = function() {
    var minAspectRatio = this.$slideshow.data('min-aspect-ratio');
    this.$slideshow.height($(document).width() / minAspectRatio);
  };

  slideshow.prototype.showMobileText = function(slideIndex) {
    var $allTextContent = this.$textWrapperMobile.find(
      selectors.textContentMobile
    );
    var currentTextContentSelector =
      selectors.textContentMobile + '-' + slideIndex;
    var $currentTextContent = this.$textWrapperMobile.find(
      currentTextContentSelector
    );
    if (
      !$currentTextContent.length &&
      this.$slideshow.find(selectors.slides).length === 1
    ) {
      this.$textWrapperMobile.hide();
    } else {
      this.$textWrapperMobile.show();
    }
    $allTextContent.hide();
    $currentTextContent.show();
  };

  function getSlideshowId($el) {
    return '#Slideshow-' + $el.data('id');
  }

  return slideshow;
})();

window.theme = window.theme || {};

theme.FormStatus = (function() {
  var selectors = {
    statusMessage: '[data-form-status]'
  };

  function init() {
    this.$statusMessage = $(selectors.statusMessage);

    if (!this.$statusMessage) return;

    this.$statusMessage.focus();
  }

  return {
    init: init
  };
})();


/* ================ TEMPLATES ================ */
(function() {
  var $filterBy = $('#BlogTagFilter');

  if (!$filterBy.length) {
    return;
  }

  $filterBy.on('change', function() {
    location.href = $(this).val();
  });
})();

window.theme = theme || {};

theme.customerTemplates = (function() {
  function initEventListeners() {
    // Show reset password form
    $('#RecoverPassword').on('click', function(evt) {
      evt.preventDefault();
      toggleRecoverPasswordForm();
    });

    // Hide reset password form
    $('#HideRecoverPasswordLink').on('click', function(evt) {
      evt.preventDefault();
      toggleRecoverPasswordForm();
    });
  }

  /**
   *
   *  Show/Hide recover password form
   *
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *
   *  Show reset password success message
   *
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }

  /**
   *
   *  Show/hide customer address forms
   *
   */
  function customerAddressForm() {
    var $newAddressForm = $('#AddressNewForm');

    if (!$newAddressForm.length) {
      return;
    }

    // Initialize observers on address selectors, defined in shopify_common.js
    if (Shopify) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(
        'AddressCountryNew',
        'AddressProvinceNew',
        {
          hideElement: 'AddressProvinceContainerNew'
        }
      );
    }

    // Initialize each edit form's country/province selector
    $('.address-country-option').each(function() {
      var formId = $(this).data('form-id');
      var countrySelector = 'AddressCountry_' + formId;
      var provinceSelector = 'AddressProvince_' + formId;
      var containerSelector = 'AddressProvinceContainer_' + formId;

      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
        hideElement: containerSelector
      });
    });

    // Toggle new/edit address forms
    $('.address-new-toggle').on('click', function() {
      $newAddressForm.toggleClass('hide');
    });

    $('.address-edit-toggle').on('click', function() {
      var formId = $(this).data('form-id');
      $('#EditAddress_' + formId).toggleClass('hide');
    });

    $('.address-delete').on('click', function() {
      var $el = $(this);
      var formId = $el.data('form-id');
      var confirmMessage = $el.data('confirm-message');

      // eslint-disable-next-line no-alert
      if (
        confirm(
          confirmMessage || 'Are you sure you wish to delete this address?'
        )
      ) {
        Shopify.postLink('/account/addresses/' + formId, {
          parameters: { _method: 'delete' }
        });
      }
    });
  }

  /**
   *
   *  Check URL for reset password hash
   *
   */
  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  return {
    init: function() {
      checkUrlHash();
      initEventListeners();
      resetPasswordSuccess();
      customerAddressForm();
    }
  };
})();


/*================ SECTIONS ================*/
window.theme = window.theme || {};

theme.Cart = (function() {
  var selectors = {
    edit: '.js-edit-toggle',
    inputQty: '.cart__qty-input',
    thumbnails: '.cart__image',
    item: '.cart__row'
  };

  var config = {
    showClass: 'cart__update--show',
    showEditClass: 'cart__edit--active',
    cartNoCookies: 'cart--no-cookies'
  };

  function Cart(container) {
    this.$container = $(container);
    this.$edit = $(selectors.edit, this.$container);
    this.$inputQuantities = $(selectors.inputQty, this.$container);
    this.$thumbnails = $(selectors.thumbnails, this.$container);

    if (!this.cookiesEnabled()) {
      this.$container.addClass(config.cartNoCookies);
    }

    this.$edit.on('click', this._onEditClick);
    this.$inputQuantities.on('change', this._handleInputQty);

    this.$thumbnails.css('cursor', 'pointer');
    this.$thumbnails.on('click', this._handleThumbnailClick);
  }

  Cart.prototype = _.assignIn({}, Cart.prototype, {
    onUnload: function() {
      this.$edit.off('click', this._onEditClick);
    },

    _onEditClick: function(evt) {
      var $evtTarget = $(evt.target);
      var $updateLine = $('.' + $evtTarget.data('target'));
      var isExpanded = $evtTarget.attr('aria-expanded') === 'true';

      $evtTarget
        .toggleClass(config.showEditClass)
        .attr('aria-expanded', !isExpanded);
      $updateLine.toggleClass(config.showClass);
    },

    _handleInputQty: function(evt) {
      var $input = $(evt.target);
      var value = $input.val();
      var itemKey = $input.data('quantity-item');
      var $itemQtyInputs = $('[data-quantity-item=' + itemKey + ']');
      $itemQtyInputs.val(value);
    },

    _handleThumbnailClick: function(evt) {
      var url = $(evt.target).data('item-url');

      window.location.href = url;
    },

    cookiesEnabled: function() {
      var cookieEnabled = navigator.cookieEnabled;

      if (!cookieEnabled) {
        document.cookie = 'testcookie';
        cookieEnabled = document.cookie.indexOf('testcookie') !== -1;
      }
      return cookieEnabled;
    }
  });

  return Cart;
})();

window.theme = window.theme || {};

theme.Collection = (function() {
  var classes = {
    hidden: 'hide'
  };

  var selectors = {
    product: '.product-card',
    productJson: '.product-json'
  };

  function Collection(container) {
    this.$container = $(container);
    this._initSwatches();
  }

  Collection.prototype = _.assignIn({}, Collection.prototype, {
    _initSwatches: function() {
      var self = this;

      // Loop through products
      $(selectors.product, this.$container).each(function() {
        var $product = $(this);
        var json = $(selectors.productJson, $product);
        var product = JSON.parse(json.html());

        // create new variant for this product, enabling swatch image switch
        var options = {
          $container: $product,
          enableHistoryState: false,
          product: product,
          displaySwatches: true
        };

        var variants = new slate.Variants(options);

        $product.on('variantImageChange', function(evt) {
          self._updateProductImage(evt, $product);
        });
      });
    },

    _updateProductImage: function(evt, $productContainer) {
      var imageSelector = '[data-image-id=' + evt.image_id + ']';
      var $imageToShow = $(imageSelector, $productContainer);
      var $imagesToHide = $('[data-image-id]:not(' + imageSelector + ')', $productContainer);

      $imagesToHide.addClass(classes.hidden);
      $imageToShow.removeClass(classes.hidden);
    }
  });

  return Collection;
})();

theme.Filters = (function() {
  var settings = {
    // Breakpoints from src/stylesheets/global/variables.scss.liquid
    mediaQueryMediumUp: 'screen and (min-width: 750px)'
  };

  var constants = {
    SORT_BY: 'sort_by'
  };

  var selectors = {
    mainContent: '#MainContent',
    filterSelection: '#FilterTags',
    sortSelection: '#SortBy',
    defaultSort: '#DefaultSortBy'
  };

  function Filters(container) {
    var $container = (this.$container = $(container));

    this.$filterSelect = $(selectors.filterSelection, $container);
    this.$sortSelect = $(selectors.sortSelection, $container);
    this.$selects = $(selectors.filterSelection, $container).add(
      $(selectors.sortSelection, $container)
    );

    this.defaultSort = this._getDefaultSortValue();
    this.$selects.removeClass('hidden');

    this.$filterSelect.on('change', this._onFilterChange.bind(this));
    this.$sortSelect.on('change', this._onSortChange.bind(this));
    this._initBreakpoints();
  }

  Filters.prototype = _.assignIn({}, Filters.prototype, {
    _initBreakpoints: function() {
      var self = this;

      enquire.register(settings.mediaQueryMediumUp, {
        match: function() {
          self._resizeSelect(self.$selects);
        }
      });
    },

    _onSortChange: function() {
      var sort = this._sortValue();
      var url = window.location.href.replace(window.location.search, '');
      var queryStringValue = slate.utils.getParameterByName('q');
      var query = queryStringValue !== null ? queryStringValue : '';

      if (sort.length) {
        var urlStripped = url.replace(window.location.hash, '');
        query = query !== '' ? '?q=' + query + '&' : '?';

        window.location.href =
          urlStripped + query + sort + selectors.mainContent;
      } else {
        // clean up our url if the sort value is blank for default
        window.location.href = url;
      }
    },

    _onFilterChange: function() {
      var filter = this._getFilterValue();

      // remove the 'page' parameter to go to the first page of results
      var search = document.location.search.replace(/\?(page=\w+)?&?/, '');

      // only add the search parameters to the url if they exist
      search = search !== '' ? '?' + search : '';

      document.location.href = filter + search + selectors.mainContent;
    },

    _getFilterValue: function() {
      return this.$filterSelect.val();
    },

    _getSortValue: function() {
      return this.$sortSelect.val() || this.defaultSort;
    },

    _getDefaultSortValue: function() {
      return $(selectors.defaultSort, this.$container).val();
    },

    _sortValue: function() {
      var sort = this._getSortValue();
      var query = '';

      if (sort !== this.defaultSort) {
        query = constants.SORT_BY + '=' + sort;
      }

      return query;
    },

    _resizeSelect: function($selection) {
      $selection.each(function() {
        var $this = $(this);
        var arrowWidth = 10;
        // create test element
        var text = $this.find('option:selected').text();
        var $test = $('<span>').html(text);

        // add to body, get width, and get out
        $test.appendTo('body');
        var width = $test.width();
        $test.remove();

        // set select width
        $this.width(width + arrowWidth);
      });
    },

    onUnload: function() {
      this.$filterSelect.off('change', this._onFilterChange);
      this.$sortSelect.off('change', this._onSortChange);
    }
  });

  return Filters;
})();

window.theme = window.theme || {};

theme.HeaderSection = (function() {
  function Header() {
    theme.Header.init();
    theme.MobileNav.init();
    theme.Search.init();
  }

  Header.prototype = _.assignIn({}, Header.prototype, {
    onUnload: function() {
      theme.Header.unload();
    }
  });

  return Header;
})();

theme.ImageAndCta = (function() {
  var $selected;
  var classes = {
    hidden: 'hide',
    rotation: 'image-and-cta__cta-image-rotation'
  };

  function ImageAndCta() {}

  ImageAndCta.prototype = _.assignIn({}, ImageAndCta.prototype, {
    onBlockSelect: function(evt) {
      $selected = $(evt.target);

      // Pause image rotation on selected block
      $selected.removeClass(classes.rotation);
      $selected.siblings('.' + classes.rotation)
        .removeClass(classes.rotation)
        .addClass(classes.hidden);
    },

    onBlockDeselect: function(evt) {
      // Restore image rotation
      $selected.addClass(classes.rotation);
      $selected.siblings('.' + classes.hidden)
        .addClass(classes.rotation)
        .removeClass(classes.hidden);
    }
  })

  return ImageAndCta;
})();

theme.Maps = (function() {
  var config = {
    zoom: 14
  };
  var apiStatus = null;
  var mapsToLoad = [];

  var errors = {
    addressNoResults: theme.strings.addressNoResults,
    addressQueryLimit: theme.strings.addressQueryLimit,
    addressError: theme.strings.addressError,
    authError: theme.strings.authError
  };

  var selectors = {
    section: '[data-section-type="map"]',
    map: '[data-map]',
    mapOverlay: '[data-map-overlay]'
  };

  var classes = {
    mapError: 'map-section--load-error',
    errorMsg: 'map-section__error errors text-center'
  };

  // Global function called by Google on auth errors.
  // Show an auto error message on all map instances.
  // eslint-disable-next-line camelcase, no-unused-vars
  window.gm_authFailure = function() {
    if (!Shopify.designMode) {
      return;
    }

    $(selectors.section).addClass(classes.mapError);
    $(selectors.map).remove();
    $(selectors.mapOverlay).after(
      '<div class="' +
        classes.errorMsg +
        '">' +
        theme.strings.authError +
        '</div>'
    );
  };

  function Map(container) {
    this.$container = $(container);
    this.$map = this.$container.find(selectors.map);
    this.key = this.$map.data('api-key');

    if (typeof this.key === 'undefined') {
      return;
    }

    if (apiStatus === 'loaded') {
      this.createMap();
    } else {
      mapsToLoad.push(this);

      if (apiStatus !== 'loading') {
        apiStatus = 'loading';
        if (typeof window.google === 'undefined') {
          $.getScript(
            'https://maps.googleapis.com/maps/api/js?key=' + this.key
          ).then(function() {
            apiStatus = 'loaded';
            initAllMaps();
          });
        }
      }
    }
  }

  function initAllMaps() {
    // API has loaded, load all Map instances in queue
    $.each(mapsToLoad, function(index, instance) {
      instance.createMap();
    });
  }

  function geolocate($map) {
    var deferred = $.Deferred();
    var geocoder = new google.maps.Geocoder();
    var address = $map.data('address-setting');

    geocoder.geocode({ address: address }, function(results, status) {
      if (status !== google.maps.GeocoderStatus.OK) {
        deferred.reject(status);
      }

      deferred.resolve(results);
    });

    return deferred;
  }

  Map.prototype = _.assignIn({}, Map.prototype, {
    createMap: function() {
      var $map = this.$map;

      return geolocate($map)
        .then(
          function(results) {
            var mapOptions = {
              zoom: config.zoom,
              center: results[0].geometry.location,
              draggable: false,
              clickableIcons: false,
              scrollwheel: false,
              disableDoubleClickZoom: true,
              disableDefaultUI: true
            };

            var map = (this.map = new google.maps.Map($map[0], mapOptions));
            var center = (this.center = map.getCenter());

            //eslint-disable-next-line no-unused-vars
            var marker = new google.maps.Marker({
              map: map,
              position: map.getCenter()
            });

            google.maps.event.addDomListener(
              window,
              'resize',
              $.debounce(250, function() {
                google.maps.event.trigger(map, 'resize');
                map.setCenter(center);
                $map.removeAttr('style');
              })
            );
          }.bind(this)
        )
        .fail(function() {
          var errorMessage;

          switch (status) {
            case 'ZERO_RESULTS':
              errorMessage = errors.addressNoResults;
              break;
            case 'OVER_QUERY_LIMIT':
              errorMessage = errors.addressQueryLimit;
              break;
            case 'REQUEST_DENIED':
              errorMessage = errors.authError;
              break;
            default:
              errorMessage = errors.addressError;
              break;
          }

          // Show errors only to merchant in the editor.
          if (Shopify.designMode) {
            $map
              .parent()
              .addClass(classes.mapError)
              .html(
                '<div class="' +
                  classes.errorMsg +
                  '">' +
                  errorMessage +
                  '</div>'
              );
          }
        });
    },

    onUnload: function() {
      if (this.$map.length === 0) {
        return;
      }
      google.maps.event.clearListeners(this.map, 'resize');
    }
  });

  return Map;
})();

theme.AjaxCart = (function() {
  function AjaxCart(container) {
    this.selectors = {
      addToCart: '.ajaxcart__add-to-cart',
      cartOpen: '.js-cart-open',
      cartContainer: '.js-cart-container',
      cartContent: '.js-cart-content'
    }

    this.classes = {
      opened: 'active'
    }

    this.$container = $(container);
    this.$cartContainer = $(this.selectors.cartContainer);
    this.$cartContent = $(this.selectors.cartContent);
    this.$cartOpen = $(this.selectors.cartOpen);

    this._initAddToCart();
    this._initCartUpdates();
    this._initAddToCartSuccessPopup();
    this._initAddToCartErrorPopup();
    this._initCartShow();
    this._initCartHide();
  }

  AjaxCart.prototype = _.assignIn({}, AjaxCart.prototype, {
    _initAddToCart: function() {
      var self = this;

      $(this.selectors.addToCart).on('click', function(evt) {  
        var $this = $(this);    
        var variantId = $this.data('variant-id');
        var variantIdList = $this.data('variant-id-list');

        if ($this.attr('disabled')) {
          return;
        }

        if (variantId) {
          evt.preventDefault();
          self.addToCart(variantId);
        }

        if (variantIdList) {
          evt.preventDefault();
          self.addMultipleToCart(variantIdList);
        }
      });
    },

    _initAddToCartSuccessPopup: function() {
      this.$container.on('item_add_success', function(_, item){
        var p = new theme.NotificationPopup('purchase-confirmed', item.product_title);
        p.show();
      });
    },

    _initAddToCartErrorPopup: function() {
      this.$container.on('item_add_fail', function(_, error) {
        var p = new theme.NotificationPopup('error', error);
        p.show();
      });
    },

    _initCartShow: function() {
      this.$cartOpen.on('click', 
        this.showCart.bind(this)
      );
    },

    _initCartHide: function() {      
      this.$container.on('showCart', 
        hideCartOnPageclick.bind(this)
      );

      function hideCartOnPageclick() {
        var self = this;
        var $page = $('body');

        $page.on('click.hideCart', function(evt) {
          if ($(evt.target).parents(self.selectors.cartContainer).length === 0) {
            self.hideCart();
            $page.off('click.hideCart');
          }
        });
      } 
    },

    _initCartUpdates: function() {
      var self = this;
      var $itemCount = $('.ajaxcart__item-count');
      var $subtotal = $('.ajaxcart__subtotal'); 
      var $hiddenEmpty = $('.ajaxcart__not-empty.hide');
      var $moreProducts = $('.ajaxcart__more-products');
      var $moreProductsContainer = $('.ajaxcart__more-products-container');

      this.$container.on('item_add_success', function(_, item){
        var $existingItem = $('.ajaxcart__variant[data-id="' + item.variant_id + '"]');

        // Increment global cart count
        var previousItemCount = +$itemCount.first().text() || 0
        $itemCount.text(previousItemCount + 1);        

        // Increment the subtotal
        var previousSubtotal = +$subtotal.first().text().replace(/\D/g, '');
        var newSubtotal = previousSubtotal + item.price
        $subtotal.text(theme.Currency.formatMoney(newSubtotal));

        // Increase the product's quantity
        if ($existingItem.length) {
          $existingItem.find('.ajaxcart__quantity').text(item.quantity);
          self._updatePromotions();
          return;
        }
        
        var previousCount = +$moreProducts.first().text();
        $moreProducts.text(previousCount + 1);

        // There is a maximum of 3 products displayed in the cart
        if ($('.cart__item', self.$container).length > 3) {                    
          $moreProductsContainer.removeClass('hide');
          self._updatePromotions();
          return;
        }        

        // go through other products and update their price
        self._addHtmlToCart(item);
        self._updatePromotions();
        $moreProductsContainer.addClass('hide');

        // Hide the empty cart prompt
        if ($hiddenEmpty.length) {
          $hiddenEmpty.removeClass('hide');
          $('.ajaxcart__empty').addClass('hide');
          $('.ajaxcart__dummy').remove();
        }
      });

      this.$container.on('cart_load_success', function(_, cartState) {
        // Update the total price
        $subtotal.text(theme.Currency.formatMoney(cartState.total_price));

        // Loop through items and update each one that is present in the ajaxcart
        $.each(cartState.items, function(_, item) {
          var $existingItem = $('.ajaxcart__variant[data-id=' + item.id + ']');

          if (!$existingItem.length) {
            return;
          }

          self._displayItemPrice($existingItem, item);
        });
      });
    },

    _addHtmlToCart: function(item) {
      var $template = $('.ajaxcart__template', this.$container);   
      var $html = $template.clone();   
      var $img = $html.find('.ajaxcart__img img');
      var $quantity = $html.find('.ajaxcart__quantity');
      var $title = $html.find('.ajaxcart__title');      

      // Update values
      $html.find('[href]').attr('href', item.url);
      $img.attr('src', item.image);
      $quantity.text(item.quantity);
      $title.text(item.product_title);
      $html.attr('data-id', item.variant_id);
      this._displayItemPrice($html, item);
      
      // Keep the template for next time we need to add html   
      $html.addClass('.ajaxcart__variant');
      $html.removeClass('ajaxcart__template');
      $html.removeClass('hide');
      $html.insertBefore($('.ajaxcart__template'));
    },

    _displayItemPrice: function($container, item) {
      var $price = $container.find('.ajaxcart__price');     
      var $priceLink = $container.find('.ajaxcart__price-link');   
      var $originalPriceContainer = $container.find('.ajaxcart__original-price-container');
      var $originalPrice = $container.find('.ajaxcart__original-price'); 

      $price.text(theme.Currency.formatMoney(item.line_price));    
      $originalPrice.text(theme.Currency.formatMoney(item.original_line_price));  

      // Show/Hide sale price
      if (item.original_line_price != item.line_price) {
        $priceLink.attr('href', '/cart');
        $originalPriceContainer.removeClass('hide');
      } else {
        $priceLink.attr('href', item.url);
        $originalPriceContainer.addClass('hide');
      }
    },

    _updateStepByStepPromotion: function(cartState) {
      if (!theme.step_discount.active) {
        return;
      }
      if (!cartState) {
        return;
      }
      var besideCartMessage = "";
      var productMessage = "";

      var validItemsCount = 0;
      for (var i = 0; i < cartState.items.length; i++) {
        var item = cartState.items[i];
        if (item.price >= theme.step_discount.minimum_price) {
          validItemsCount += item.quantity;
        }
      }

      if (validItemsCount >= 4) {
        besideCartMessage = stairs_discount_beside_cart_messages[4];
        productMessage = stairs_discount_product_messages[4];
      } else {
        besideCartMessage = stairs_discount_beside_cart_messages[validItemsCount];
        productMessage = stairs_discount_product_messages[validItemsCount];
      }

      $('#beside-cart-promotion-explication-holder').html(besideCartMessage);
      $('#promotion-explication-holder').html(productMessage);
    },

    /*
    * Fetch cart-wide promotions and apply the discounts individually
    * to the products displayed in the cart
    */
    _updatePromotions: function() {
      var $container = this.$container;
      ajaxCart = this;

      // https://github.com/Shopify/theme-scripts/tree/master/packages/theme-cart#getstate
      Shopify.theme.cart.getState()
        .then(function(res) {
          ajaxCart._updateStepByStepPromotion(res)
          $container.trigger('cart_load_success', [res])
        });
    },

    addToCart: function(productId) {
      var $container = this.$container;

      // https://github.com/Shopify/theme-scripts/tree/master/packages/theme-cart#additemid--quantity-properties-
      return Shopify.theme.cart.addItem(productId)
        .then(function(res) {
          $container.trigger('item_add_success', [res]);
        })
        .catch(function(error) {
          $container.trigger('item_add_fail', [error]);
        })
    },

    addMultipleToCart: function(productIds) {
      var self = this;

      function addIdsSynchronously() {
        var id = productIds.shift();
        id && self.addToCart(id).then(addIdsSynchronously)
      }

      addIdsSynchronously();
    },

    hideCart: function() {
      if (!this.isOpen) {
        return;
      }

      this.isOpen = false;

      this.$cartOpen.removeClass(this.classes.opened);
      this.$cartContent.removeClass(this.classes.opened);
      this.$cartContainer.css('max-height', '');
    },

    showCart: function(evt) {
      if (this.isOpen) {
        return;
      }

      // prevent triggering click on the body
      evt && evt.stopPropagation && evt.stopPropagation();
      this.isOpen = true;

      this.$cartOpen.addClass(this.classes.opened);
      this.$cartContent.addClass(this.classes.opened);
      this.$cartContainer.css('max-height', this.$cartContent.outerHeight() + 'px');

      this.$container.trigger('showCart');
    }
  })

  return AjaxCart;
})();

/* eslint-disable no-new */
theme.Product = (function() {
  function Product(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');

    this.settings = {
      // Breakpoints from src/stylesheets/global/variables.scss.liquid
      mediaQueryMediumUp: 'screen and (min-width: 750px)',
      mediaQuerySmall: 'screen and (max-width: 749px)',
      bpSmall: false,
      enableHistoryState: $container.data('enable-history-state') || false,
      namespace: '.slideshow-' + sectionId,
      sectionId: sectionId,
      sliderActive: false,
      zoomEnabled: false
    };

    this.selectors = {
      addToCart: '#AddToCart-' + sectionId,
      addToCartText: '#AddToCartText-' + sectionId,
      errorQuantityMessage: '#error-quantity-' + sectionId,
      quantity: '#Quantity-' + sectionId,
      SKU: '.variant-sku',
      productStatus: '[data-product-status]',
      originalSelectorId: '#ProductSelect-' + sectionId,
      productImageWraps: '.product-single__photo',
      productThumbImages: '.product-single__thumbnail--' + sectionId,
      productThumbs: '.product-single__thumbnails-' + sectionId,
      productFeaturedImage: '.product-featured-img',
      productThumbsWrapper: '.js.thumbnails-wrapper',
      saleLabel: '.product-price__sale-label-' + sectionId,
      singleOptionSelector: '.single-option-selector-' + sectionId,
      shopifyPaymentButton: '.shopify-payment-button',
      priceContainer: '[data-price]',
      percentageDifference: '[data-percentage-difference]',
      regularPrice: '[data-regular-price]',
      salePrice: '[data-sale-price]',
      collapsibleToggle: '[data-product-collapsible]',
      collapsibleTargetAttr: 'data-product-fragment',
      tabToggle: '[data-product-tab]',
      tabToggleSize: '[data-product-size-tab]',
      tabContentAttr: 'data-product-content',
      tabContentSizeAttr: 'data-product-size-content',
      swatchSizeChart: '.swatch--size-chart'
    };

    this.classes = {
      hidden: 'medium-up--hide',
      productOnSale: 'price--on-sale',
      productUnavailable: 'price--unavailable'
    };

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$('#ProductJson-' + sectionId).html()) {
      return;
    }

    this.productSingleObject = JSON.parse(
      document.getElementById('ProductJson-' + sectionId).innerHTML
    );

    this.settings.zoomEnabled = $(this.selectors.productImageWraps).hasClass(
      'js-zoom-enabled'
    );

    this._initBreakpoints();
    this._stringOverrides();
    this._initVariants();
    this._initImageSwitch();
    this._initAddToCart();
    this._setActiveThumbnail();
    this._initTabs();
    this._initInformationCollapsible();
    this._initSizeChart();
  }

  Product.prototype = _.assignIn({}, Product.prototype, {
    _stringOverrides: function() {
      theme.productStrings = theme.productStrings || {};
      $.extend(theme.strings, theme.productStrings);
    },

    _initBreakpoints: function() {
      var self = this;

      enquire.register(this.settings.mediaQuerySmall, {
        match: function() {
          // initialize thumbnail slider on mobile if more than three thumbnails
          if ($(self.selectors.productThumbImages).length > 3) {
            self._initThumbnailSlider();
          }

          // destroy image zooming if enabled
          if (self.settings.zoomEnabled) {
            $(self.selectors.productImageWraps).each(function() {
              _destroyZoom(this);
            });
          }

          self.settings.bpSmall = true;
        },
        unmatch: function() {
          if (self.settings.sliderActive) {
            self._destroyThumbnailSlider();
          }

          self.settings.bpSmall = false;
        }
      });

      enquire.register(this.settings.mediaQueryMediumUp, {
        match: function() {
          if (self.settings.zoomEnabled) {
            $(self.selectors.productImageWraps).each(function() {
              _enableZoom(this);
            });
          }
        }
      });
    },

    _initVariants: function() {
      var options = {
        $container: this.$container,
        enableHistoryState:
          this.$container.data('enable-history-state') || false,
        singleOptionSelector: this.selectors.singleOptionSelector,
        originalSelectorId: this.selectors.originalSelectorId,
        product: this.productSingleObject
      };

      this.variants = new slate.Variants(options);

      this.$container.on(
        'variantChange' + this.settings.namespace,
        this._updateAvailability.bind(this)
      );
      this.$container.on(
        'variantImageChange' + this.settings.namespace,
        this._updateImages.bind(this)
      );
      this.$container.on(
        'variantPriceChange' + this.settings.namespace,
        this._updatePrice.bind(this)
      );

      // Dirty workaround because we don't have variant images.
      // Force the selection of the currently selected color variant
      // without the need to choose a size
      var selectedVariant = undefined;
      var colorParam = slate.utils.getParameterByName('co')

      if (colorParam) {
        var color_param = slate.utils.spacesTo_(colorParam)

        // select the swatch
        var $swatchForColor = $('.swatch[data-value="' + colorParam + '"]', this.$container);
        this.variants.selectSwatch($swatchForColor);

        // select the option
        var $optionForColor = $('option[value="' + colorParam + '"]', this.$container);
        $optionForColor.parent('select').val(colorParam);

        // find a variant with the selected color
        var selectedVariant = _.find(this.variants.product.variants, function(variant) {
          return !!~variant.options.indexOf(colorParam)
        });
      } else {
        var options = this.variants._getCurrentOptions();
        if(options.length) {
          color_param = slate.utils.spacesTo_(options[0].value);
        } else {
          color_param = ''
        }
      }

      var $availableImages = $(this.selectors.productThumbsWrapper + ' .product-single__thumbnails-item.co-' + color_param, this.$container);
      if ($availableImages.length) {
        $newFeaturedImage = $availableImages.first();
        imageId = $newFeaturedImage.find('a').data('thumbnail-id');
        this._updateImages({ image_id: imageId });
        selectedVariant && this.variants._updateMoreViewsFilter(selectedVariant);
      }
    },

    _initImageSwitch: function() {
      if (!$(this.selectors.productThumbImages).length) {
        return;
      }

      var self = this;

      $(this.selectors.productThumbImages)
        .on('click', function(evt) {
          evt.preventDefault();
          var $el = $(this);

          var imageId = $el.data('thumbnail-id');
          self._switchImage(imageId);
          self._setActiveThumbnail(imageId);
        })
        .on('keyup', self._handleImageFocus.bind(self));
    },

    _initAddToCart: function() {
      var self = this;
      var $quantityInput = $(self.selectors.quantity);

      if ($quantityInput.length === 0) return;

      $(self.selectors.addToCart).on('click', function(evt) {
        var isInvalidQuantity = $quantityInput.val() <= 0;

        $(self.selectors.errorQuantityMessage).toggleClass(
          self.classes.hidden,
          !isInvalidQuantity
        );

        if (isInvalidQuantity) {
          $quantityInput
            .attr(
              'aria-describedby',
              'error-quantity-' + self.settings.sectionId
            )
            .attr('aria-invalid', true);
          $(self.selectors.errorQuantityMessage).focus();
          evt.preventDefault();
        } else {
          $quantityInput
            .removeAttr('aria-describedby')
            .removeAttr('aria-invalid');
        }
      });
    },

    _setActiveThumbnail: function(imageId) {
      var activeClass = 'active-thumb';

      // If there is no element passed, find it by the current product image
      if (typeof imageId === 'undefined') {
        imageId = $(this.selectors.productImageWraps + ":not('.hide')").data(
          'image-id'
        );
      }

      var $thumbnail = $(
        this.selectors.productThumbImages +
          "[data-thumbnail-id='" +
          imageId +
          "']"
      );

      $(this.selectors.productThumbImages)
        .removeClass(activeClass)
        .removeAttr('aria-current');

      $thumbnail.addClass(activeClass);
      $thumbnail.attr('aria-current', true);
    },

    _initTabs: function() {
      var tabs = this.selectors.tabContentAttr;
      var $tabToggle = $(this.selectors.tabToggle);

      $tabToggle.on('click', function() {
        var $this = $(this);        

        // hide other tabs
        $tabToggle.removeClass('active');
        $('[' + tabs + ']').removeClass('active');

        // select tab
        var target = $this.attr('data-product-tab');
        $this.addClass('active');
        $('[data-product-content="' + target + '"]').addClass('active');
      });

      var tabsSize = this.selectors.tabContentSizeAttr;
      var $tabToggleSize = $(this.selectors.tabToggleSize);

      $tabToggleSize.on('click', function() {
        var $this = $(this);        

        // hide other tabs
        $tabToggleSize.removeClass('active');
        $('[' + tabsSize + ']').removeClass('active');

        // select tab
        var target = $this.attr('data-product-size-tab');
        $this.addClass('active');
        $('[data-product-size-content="' + target + '"]').addClass('active');
      });
    },

    _initInformationCollapsible: function() {
      var collapsibleTargetAttr = this.selectors.collapsibleTargetAttr;
      var $collapsibleToggle = $(this.selectors.collapsibleToggle);

      $collapsibleToggle.on('click', function() {
        var $this = $(this);
        var target = $this.attr('data-product-collapsible');

        $('[' + collapsibleTargetAttr + ']').removeClass('active');
        $this.toggleClass('active')
        
        // show target
        if ($this.hasClass('active')) {                  
          $this.siblings().removeClass('active');
          $('[' + collapsibleTargetAttr + '=' + target + ']').addClass('active');
        }
      });
    },

    _initSizeChart: function() {
      var self = this;

      $(this.selectors.swatchSizeChart).on(
        'click',
        function() {
          var $this = $(this);
          var index = $this.data('value');
          var unit = $this.data('type');

          if (!index) {
            index = $(self.selectors.swatchSizeChart + '.swatch--selected[data-value]').data('value');
          }
          if (!unit) {
            unit = $(self.selectors.swatchSizeChart + '.swatch--selected[data-type]').data('type');
          }

          $this.addClass('swatch--selected');
          $this.siblings().removeClass('swatch--selected');
          //$this.parents('.js-size-chart').find('[data-index]').addClass('hide');
          //$this.parents('.js-size-chart').find('[data-index="' + index + '"][data-unit="' + unit + '"]').removeClass('hide');
          var parent = $this.parents('.js-size-chart-measures')
          var oldUnit = parent.data('unit')
          parent.data('unit', unit)
          parent.removeClass(oldUnit)
          parent.addClass(unit)

        }
      )
    },

    _switchImage: function(imageId) {
      var $newImage = $(
        this.selectors.productImageWraps + "[data-image-id='" + imageId + "']",
        this.$container
      );
      var $otherImages = $(
        this.selectors.productImageWraps +
          ":not([data-image-id='" +
          imageId +
          "'])",
        this.$container
      );

      /*
      * #164917420: Check length to resolve an issue where no image
      * would be displayed in the product popup (looks-bal) for a product with
      * no thumbnails, while there are products with thumbnails on the page
      */ 
      if ($newImage.length) {
        $newImage.removeClass(this.classes.hidden);
        $otherImages.addClass(this.classes.hidden);
      }
    },

    _handleImageFocus: function(evt) {
      if (evt.keyCode !== slate.utils.keyboardKeys.ENTER) return;

      $(this.selectors.productFeaturedImage + ':visible').focus();
    },

    _initThumbnailSlider: function() {
      var options = {
        slidesToShow: 4,
        slidesToScroll: 3,
        infinite: false,
        prevArrow: '.thumbnails-slider__prev--' + this.settings.sectionId,
        nextArrow: '.thumbnails-slider__next--' + this.settings.sectionId,
        responsive: [
          {
            breakpoint: 321,
            settings: {
              slidesToShow: 3
            }
          }
        ]
      };

      $(this.selectors.productThumbs, this.$container).slick(options);

      // Accessibility concerns not yet fixed in Slick Slider
      $(this.selectors.productThumbsWrapper, this.$container)
        .find('.slick-list')
        .removeAttr('aria-live');
      $(this.selectors.productThumbsWrapper, this.$container)
        .find('.slick-disabled')
        .removeAttr('aria-disabled');

      this.settings.sliderActive = true;
    },

    _destroyThumbnailSlider: function() {
      $(this.selectors.productThumbs).slick('unslick');
      this.settings.sliderActive = false;

      // Accessibility concerns not yet fixed in Slick Slider
      $(this.selectors.productThumbsWrapper, this.$container)
        .find('[tabindex="-1"]')
        .removeAttr('tabindex');
    },

    _liveRegionText: function(variant) {
      // Dummy content for live region
      var liveRegionText = '[Availability] [Regular] [$$] [Sale] [$]';

      if (!variant) {
        liveRegionText = theme.strings.unavailable;
        return liveRegionText;
      }

      // Update availability
      var availability = variant.available ? '' : theme.strings.soldOut + ',';
      liveRegionText = liveRegionText.replace('[Availability]', availability);

      // Update pricing information
      var regularLabel = '';
      var regularPrice = theme.Currency.formatMoney(
        variant.price,
        theme.moneyFormat
      );
      var saleLabel = '';
      var salePrice = '';

      if (variant.compare_at_price > variant.price) {
        regularLabel = theme.strings.regularPrice;
        regularPrice =
          theme.Currency.formatMoney(
            variant.compare_at_price,
            theme.moneyFormat
          ) + ',';
        saleLabel = theme.strings.sale;
        salePrice = theme.Currency.formatMoney(
          variant.price,
          theme.moneyFormat
        );
      }

      liveRegionText = liveRegionText
        .replace('[Regular]', regularLabel)
        .replace('[$$]', regularPrice)
        .replace('[Sale]', saleLabel)
        .replace('[$]', salePrice)
        .trim();

      return liveRegionText;
    },

    _updateLiveRegion: function(evt) {
      var variant = evt.variant;
      var liveRegion = this.container.querySelector(
        this.selectors.productStatus
      );
      liveRegion.textContent = this._liveRegionText(variant);
      liveRegion.setAttribute('aria-hidden', false);

      // hide content from accessibility tree after announcement
      setTimeout(function() {
        liveRegion.setAttribute('aria-hidden', true);
      }, 1000);
    },

    _updateAddToCart: function(evt) {
      var variant = evt.variant;

      if (variant) {
        if (variant.available) {
          $(this.selectors.addToCart).prop('disabled', false).data('variant-id', variant.id);
          $(this.selectors.addToCartText).text(theme.strings.addToCart);
          $(this.selectors.shopifyPaymentButton, this.$container).show();
        } else {
          // The variant doesn't exist, disable submit button and change the text.
          // This may be an error or notice that a specific variant is not available.
          $(this.selectors.addToCart).prop('disabled', true);
          $(this.selectors.addToCartText).text(theme.strings.soldOut);
          $(this.selectors.shopifyPaymentButton, this.$container).hide();
        }
      } else {
        $(this.selectors.addToCart).prop('disabled', true);
        $(this.selectors.addToCartText).text(theme.strings.no_size_selected);
        $(this.selectors.shopifyPaymentButton, this.$container).hide();
      }
    },

    _updateAvailability: function(evt) {
      // update form submit
      this._updateAddToCart(evt);
      // update live region
      this._updateLiveRegion(evt);

      this._updatePrice(evt);
    },

    _updateImages: function(evt) {
      var variant = evt.variant;
      var imageId = 0;

      if (variant && variant.featured_image) {
        imageId = variant.featured_image.id;
      } else if(evt.image_id) {
        imageId = evt.image_id;
      }

      this._switchImage(imageId);
      this._setActiveThumbnail(imageId);
    },

    _updatePrice: function(evt) {
      var variant = evt.variant;
      if (!variant) { return; }
      var $priceContainer = $(this.selectors.priceContainer, this.$container);
      var $regularPrice = $(this.selectors.regularPrice, $priceContainer);
      var $salePrice = $(this.selectors.salePrice, $priceContainer);
      var $percentageDifference = $(this.selectors.percentageDifference, $priceContainer)

      // Reset product price state
      $priceContainer
        .removeClass(this.classes.productUnavailable)
        .removeClass(this.classes.productOnSale)
        .removeAttr('aria-hidden');

      // Unavailable
      if (!variant) {
        $priceContainer
          .addClass(this.classes.productUnavailable)
          .attr('aria-hidden', true);
        return;
      }

      // On sale
      if (variant.compare_at_price > variant.price) {
        $regularPrice.html(
          theme.Currency.formatMoney(
            variant.compare_at_price,
            theme.moneyFormat
          )
        );
        $salePrice.html(
          theme.Currency.formatMoney(variant.price, theme.moneyFormat)
        );
        $percentageDifference.html(
          '(-' + Math.trunc((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price) + '%)'
          )
        $priceContainer.addClass(this.classes.productOnSale);
      } else {
        // Regular price
        $regularPrice.html(
          theme.Currency.formatMoney(variant.price, theme.moneyFormat)
        );
      }
    },

    _updateSKU: function(evt) {
      var variant = evt.variant;

      // Update the sku
      $(this.selectors.SKU).html(variant.sku);
    },

    onUnload: function() {
      this.$container.off(this.settings.namespace);
    }
  });

  function _enableZoom(el) {
    var zoomUrl = $(el).data('zoom');
    $(el).zoom({
      url: zoomUrl
    });
  }

  function _destroyZoom(el) {
    $(el).trigger('zoom.destroy');
  }

  return Product;
})();

theme.Quotes = (function() {
  var config = {
    mediaQuerySmall: 'screen and (max-width: 749px)',
    mediaQueryMediumUp: 'screen and (min-width: 750px)',
    slideCount: 0
  };
  var defaults = {
    accessibility: true,
    arrows: false,
    dots: true,
    autoplay: false,
    touchThreshold: 20,
    slidesToShow: 3,
    slidesToScroll: 3
  };

  function Quotes(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');
    var wrapper = (this.wrapper = '.quotes-wrapper');
    var slider = (this.slider = '#Quotes-' + sectionId);
    var $slider = $(slider, wrapper);

    var sliderActive = false;
    var mobileOptions = $.extend({}, defaults, {
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true
    });

    config.slideCount = $slider.data('count');

    // Override slidesToShow/Scroll if there are not enough blocks
    if (config.slideCount < defaults.slidesToShow) {
      defaults.slidesToShow = config.slideCount;
      defaults.slidesToScroll = config.slideCount;
    }

    $slider.on('init', this.a11y.bind(this));

    enquire.register(config.mediaQuerySmall, {
      match: function() {
        initSlider($slider, mobileOptions);
      }
    });

    enquire.register(config.mediaQueryMediumUp, {
      match: function() {
        initSlider($slider, defaults);
      }
    });

    function initSlider(sliderObj, args) {
      if (sliderActive) {
        sliderObj.slick('unslick');
        sliderActive = false;
      }

      sliderObj.slick(args);
      sliderActive = true;
    }
  }

  Quotes.prototype = _.assignIn({}, Quotes.prototype, {
    onUnload: function() {
      enquire.unregister(config.mediaQuerySmall);
      enquire.unregister(config.mediaQueryMediumUp);

      $(this.slider, this.wrapper).slick('unslick');
    },

    onBlockSelect: function(evt) {
      // Ignore the cloned version
      var $slide = $(
        '.quotes-slide--' + evt.detail.blockId + ':not(.slick-cloned)'
      );
      var slideIndex = $slide.data('slick-index');

      // Go to selected slide, pause autoplay
      $(this.slider, this.wrapper).slick('slickGoTo', slideIndex);
    },

    a11y: function(event, obj) {
      var $list = obj.$list;
      var $wrapper = $(this.wrapper, this.$container);

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live');

      // When an element in the slider is focused set aria-live
      $wrapper.on('focusin', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.attr('aria-live', 'polite');
        }
      });

      // Remove aria-live
      $wrapper.on('focusout', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.removeAttr('aria-live');
        }
      });
    }
  });

  return Quotes;
})();

theme.CarouselSection = (function() {
  function CarouselSection(container) {
    this.$container = $(container);
    this._initSlick()
  }

  CarouselSection.prototype = _.assignIn({}, CarouselSection.prototype, {
    _initSlick: function() {
      var sectionSettings = this.$container.data('settings')

      this.$container.slick(_.assignIn({
        infinite: false,
        
        // Display only one slide on mobile
        responsive: [{
          breakpoint: 750,
          settings: {
            slidesToShow: 1
          }
        }]
      }, sectionSettings))
    }
  })

  return CarouselSection
})();

theme.slideshows = {};

theme.SlideshowSection = (function() {
  function SlideshowSection(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');
    var slideshow = (this.slideshow = '#Slideshow-' + sectionId);

    theme.slideshows[slideshow] = new theme.Slideshow(slideshow, sectionId);
  }

  return SlideshowSection;
})();

theme.SlideshowSection.prototype = _.assignIn(
  {},
  theme.SlideshowSection.prototype,
  {
    onUnload: function() {
      delete theme.slideshows[this.slideshow];
    },

    onBlockSelect: function(evt) {
      var $slideshow = $(this.slideshow);
      var adaptHeight = $slideshow.data('adapt-height');

      if (adaptHeight) {
        theme.slideshows[this.slideshow].setSlideshowHeight();
      }

      // Ignore the cloned version
      var $slide = $(
        '.slideshow__slide--' + evt.detail.blockId + ':not(.slick-cloned)'
      );
      var slideIndex = $slide.data('slick-index');

      // Go to selected slide, pause auto-rotate
      $slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
    },

    onBlockDeselect: function() {
      // Resume auto-rotate
      $(this.slideshow).slick('slickPlay');
    }
  }
);

theme.ImageSlider = (function() {
  var settings = {
    // Breakpoints from src/stylesheets/global/variables.scss.liquid
    mediaQuerySmall: 'screen and (max-width: 749px)',
    initializedClass: 'slick-initialized'
  };

  var selectors = {
    slickSlide: '.slick-slide',
    slide: '.slick-js__slide'
  };

  function ImageSlider(container) {
    this.$slider = $(container)
    this._initSlider();
  }

  ImageSlider.prototype = _.assignIn({}, ImageSlider.prototype, {
    _initSlider: function() {
      var self = this;

      enquire.register(settings.mediaQuerySmall, {
        match: function() {
          self._init();
        },
        unmatch: function() {
          self._destroy();
        }        
      });
    },

    _init: function() {
       if (!this.$slider.hasClass(settings.initializedClass)) {
        this.$slider.slick({ 
          dots: true,
          dotsClass: 'product-dots',
          customPaging: function(slider, i) {
            return '<a>' + (i + 1) + '</a>'
          }
        });

        // Copy classnames to parent for filtering
        $(selectors.slide).each(function(i, slide) {
          var $slide = $(slide)
          var $parent = $slide.parents(selectors.slickSlide)
          $parent.addClass($slide.attr('class'))
        })

        // Hide the <noscript> tags
        this.$slider.slick('slickFilter', selectors.slide)
      }
    },

    _destroy: function() {
      if (this.$slider.hasClass(settings.initializedClass)) {
        this.$slider.slick('unslick');
      }      
    }
  });

  return ImageSlider;
})();

theme.SideBySide = (function() {
  var $sideLeft
  var $sideRight

  function SideBySide(container) {
    var $container = $(container);
    $sideLeft = $('.side-by-side__left', $container)
    $sideRight = $('.side-by-side__right', $container)

    this._initParallax()
    this._fixParallaxOverflow()
  }

  SideBySide.prototype = _.assignIn({}, SideBySide.prototype, {
    _initParallax: function() {     
      function initJarallax(_, element) {
        var $element = $(element)
        var speed = $element.data('speed')
        
        $element.jarallax({
          imgElement: 'img',
          speed: speed,
          keepImg: true
        })
      }

      // Init Jarallax
      $sideLeft.each(initJarallax);
      $sideRight.each(initJarallax);
    },

    _destroyParallax: function() {
      $sideLeft.jarallax('destroy')
      $sideRight.jarallax('destroy')
    },

    _fixParallaxOverflow: function() {
      $sideLeft.each(function(_, el){
        var $el = $(el)
        var $img = $el.find('img')
        var imgHeight = $img.height()

        /*
        * Support lazy loading, where we don't know the height
        * of the container until the image is fetched from the server
        */
        if (imgHeight === 0) {
          $img[0].onload = function() {
            $el.height(this.height)
          }
        } else {
          $el.height(imgHeight)
        }
      })
    },

    _onSectionLoad: function() {
      this._initParallax()
    },
  })

  return SideBySide;
})();

theme.Modals = (function() {
  function Modal(id, name, options) {
    var defaults = {
      close: '.js-modal-close',
      open: '.js-modal-open-' + name,
      openClass: 'modal--is-active'
    };

    this.$modal = $('#' + id);

    if (!this.$modal.length) {
      return false;
    }

    this.nodes = {
      $parent: $('html').add('body')
    };
    this.config = $.extend(defaults, options);
    this.modalIsOpen = false;
    // eslint-disable-next-line shopify/jquery-dollar-sign-reference
    this.$focusOnOpen = this.config.focusOnOpen
      ? $(this.config.focusOnOpen)
      : this.$modal;
    this.init();
  }

  Modal.prototype.init = function() {
    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$modal.find(this.config.close).on('click', $.proxy(this.close, this));
  };

  Modal.prototype.open = function(evt) {
    // Keep track if modal was opened from a click, or called by another function
    var externalCall = false;

    // don't open an opened modal
    if (this.modalIsOpen) {
      return;
    }

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the modal opens, the click event bubbles up to $nodes.page
    // which closes the modal.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.modalIsOpen && !externalCall) {
      this.close();
    }

    // Close other modals with same id
    var uniqueId = this.$modal.data('unique-id');
    if (uniqueId) {
      var $modals = $('[data-unique-id=' + uniqueId + ']');
      var closeSelector = this.config.close;
      var currentId = this.$modal.attr('id');

      $modals.each(function (_, modal) {
        if (modal.id !== currentId) {
          $(modal).find(closeSelector).click();
        }
      });
    }

    this.$modal.addClass(this.config.openClass);
    this.nodes.$parent.addClass(this.config.openClass);

    this.modalIsOpen = true;

    // Set focus on modal
    slate.a11y.trapFocus({
      $container: this.$modal,
      $elementToFocus: this.$focusOnOpen,
      namespace: 'modal_focus'
    });

    this.bindEvents();
  };

  Modal.prototype.openOnce = function() {
    var name = this._getName();

    if (!name) {
      return;
    }

    var cookieKey = name + '_opened_once';
    if (!~document.cookie.indexOf(cookieKey)) {
      this.$modal.one('modal.hidden', _createCookie);
      this.open();
    }

    function _createCookie() {
      createCookie(cookieKey, 'true');
    }
  }

  Modal.prototype.openEveryNDays = function(days) {
    var name = this._getName();

    if (!name) {
      return;
    }

    var cookieKey = name + '_opened_x';
    if (!~document.cookie.indexOf(cookieKey)) {
      this.$modal.one('modal.hidden', _createCookie);
      this.open();
    } else {
      return false
    }

    function _createCookie() {
      createCookie(cookieKey, 'true', days);
    }

    return true;
  }

  Modal.prototype.solo = function() {
    var $soloModal = this.$modal
    var $otherActiveModals = $('.modal--is-active').filter(function(_, modal){
      return !$(modal).is($soloModal)
    })

    function hideOtherModals() {
      $('body').addClass('solo-modal--is-active')
      $otherActiveModals.removeClass('modal--is-active')
    }

    function unhideOtherModals() {
      $('body').removeClass('solo-modal--is-active')
      $otherActiveModals.addClass('modal--is-active')
    }

    hideOtherModals();
    this.$modal.one('modal.hidden', unhideOtherModals);
  }

  Modal.prototype.soloEveryNDays = function(days) {
    if (this.openEveryNDays(days)) {
      var self = this

      // Let other modals open
      setTimeout(function() {
        self.solo()
      })
    }
  }

  Modal.prototype.close = function() {
    // don't close a closed modal
    if (!this.modalIsOpen) {
      return;
    }

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    this.$modal.removeClass(this.config.openClass);
    this.nodes.$parent.removeClass(this.config.openClass);

    this.modalIsOpen = false;

    // Remove focus on modal
    slate.a11y.removeTrapFocus({
      $container: this.$modal,
      namespace: 'modal_focus'
    });

    this.unbindEvents();
    this.$modal.trigger('modal.hidden');
  };

  Modal.prototype.bindEvents = function() {
    // Pressing escape closes modal
    this.nodes.$parent.on(
      'keyup.modal',
      $.proxy(function(evt) {
        if (evt.keyCode === 27) {
          this.close();
        }
      }, this)
    );
  };

  Modal.prototype.unbindEvents = function() {
    this.nodes.$parent.off('.modal');
  };

  Modal.prototype._getName = function() {
    return this.$modal.data('modal');
  }

  return Modal;
})();

// Modals configurable through shopify settings
// Ideally newsletter and language would inherit from this, but Ilias 
// don't know how prototype inheritance works.
theme.CustomizableModalSection = (function() {
  function CustomizableModal(modal) {
    var $modal = $(modal);
    this.modal = new theme.Modals($modal.attr('id'), $modal.data('modal'));
  }

  CustomizableModal.prototype = _.assignIn({}, CustomizableModal.prototype, {
    onSelect: function() {
      this.modal.open();
    },

    onDeselect: function() {
      this.modal.close();
    }
  });

  return CustomizableModal;
})();

theme.NewsletterModalSection = (function() {
  function NewsLetterModal(modal) {
    var $modal = $(modal);
    this.modal = new theme.Modals($modal.attr('id'), $modal.data('modal'));
    this.modal.openOnce();
  }

  NewsLetterModal.prototype = _.assignIn({}, NewsLetterModal.prototype, {
    onSelect: function() {
      this.modal.open();
    },

    onDeselect: function() {
      this.modal.close();
    }
  })

  return NewsLetterModal;
})();

theme.LanguageModalSection = (function() {
  function LanguageModal(modal) {

    $('.submit__language').click(function(event) {
      var $selectBox = $("#SelectLanguage")
      var newLink = $selectBox.find(":selected").data('link')
      if (newLink) {
        createCookie('language_opened_x', 'true', 30);
        window.location = newLink
      } else {
        $selectBox.addClass('input--error')
      }
    })

    var $modal = $(modal);
    this.modal = new theme.Modals($modal.attr('id'), $modal.data('modal'));
    this.modal.soloEveryNDays(30);
  }



  LanguageModal.prototype = _.assignIn({}, LanguageModal.prototype, {
    onSelect: function() {
      this.modal.open();
    },

    onDeselect: function() {
      this.modal.close();
    }
  })

  return LanguageModal
})();

theme.LookboxSection = (function() {
  var classes = {
    hidden: 'hide',
    selectedCollection: 'collection--selected',
    selectedLookbox: 'selected'
  };

  var selectors = {
    addToCart: '.lookbox__add-to-cart',
    collectionContainer: '.collection-grid-item-container',
    collectionLink: '.collection-grid-item__link',
    featuredImage: '.js-image-featured',
    featuredImageIdPrefix: '.js-image-featured--',
    lookboxCollection: '.lookbox__collection',
    lookboxProduct: '.lookbox__product',
    productJson: '.product-json',
    selectedLookbox: '.lookbox__collection.selected',
    singleOptionSelector: '.single-option-selector',
    sizeSelect: '[data-index=option2].swatch--variant',
    selectedSize: '[data-index=option2].swatch--variant.swatch--selected'
  };

  var settings = {
    // Breakpoint from src/stylesheets/global/variables.scss.liquid
    mediaQueryMediumUp: 'screen and (min-width: 750px)'
  };

  function Lookbox(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');

    this.$collectionLinks = $(selectors.collectionLink, $container);

    this._updateAddToCart();
    this._initBreakpoints();
    this._initVariants();
    this._stickSidebar();
  }

  Lookbox.prototype = _.assignIn({}, Lookbox.prototype, {
    _disableLookToggle: function() {
      this.$collectionLinks.off('click.lookToggle')
    },

    _enableLookToggle: function() {
      var self = this;

      this.$collectionLinks.on('click.lookToggle', function(evt) {
        evt.preventDefault();
        var collectionId = $(evt.delegateTarget).data('collection-id');

        self._showLookForCollectionId(collectionId);
        self._selectCollectionId(collectionId);
        self._updateAddToCart();
      })
    },

    _initBreakpoints: function() {
      var self = this;

      enquire.register(settings.mediaQueryMediumUp, {
        match: self._enableLookToggle.bind(self),
        unmatch: self._disableLookToggle.bind(self)
      });
    },

    _selectCollectionId: function(id) {
      var $gridItems = $(selectors.collectionContainer, this.$container)
      $gridItems.removeClass(classes.selectedCollection);
      $gridItems.filter('[data-collection-id=' + id + ']').addClass(classes.selectedCollection);
    },

    _initVariants: function() {
      var self = this;
      self.variants = {}
      $(selectors.productJson, this.$container).each(function(_, el) {
        var $el = $(el);
        var $lookbox = $(el).parents('.lookbox__collection');
        var product = JSON.parse($el.html());
        var $productContainer = $(selectors.lookboxProduct + '[data-product-id=' + product.id + ']', $lookbox);
        var options = {
          $container: $productContainer,
          namespace: product.id,
          singleOptionSelector: selectors.singleOptionSelector,
          product: product
        }

        $productContainer.on(
          'variantChange.' + product.id,
          self._onVariantChange.bind(self)
        );

        $productContainer.on(
          'variantImageChange.' + product.id,
          self._onVariantImageChange.bind(self)
        );

        self.variants[product.id] = new slate.Variants(options);
      })
    },

    _onVariantChange: function(evt) {
      // this is called multiple times, why?
      this._setProductVariant(evt.namespace, evt.variant);
      this._updateAddToCart();
    },

    _onVariantImageChange(evt) {
      var $productContainer = $('[data-product-id=' + evt.namespace + ']', this.$container)
      var $images = $(selectors.featuredImage, $productContainer);
      var $featuredImage = $(selectors.featuredImageIdPrefix + evt.image_id, $productContainer);

      if ($featuredImage.length) {
        $images.addClass(classes.hidden);
        $featuredImage.removeClass(classes.hidden);
      }
    },

    _setProductVariant: function(productId, variant) {
      if (!variant) {
        return;
      }

      $('[data-product-id=' + productId + ']', this.$container).data('variant-id', variant.id);
    },

    _stickSidebar: function() {
      var updateSticky = slate.stickElement({
        element: document.querySelector('.lookbox'),
        container: document.querySelector('.js-lookbox-container'),
        topSection: document.querySelector('#shopify-section-header'),
        bottomSection: document.querySelector('.site-footer')
      });
      window.addEventListener('scroll', updateSticky);
    },

    /*
    * Go through each variant. If one of them has an unselected size,
    * disable add-to-cart
    */ 
    _updateAddToCart: function() {
      var $currentCollection = $(selectors.selectedLookbox, this.$container);
      var $products = $(selectors.lookboxProduct, $currentCollection);
      var $addToCart = $(selectors.addToCart, $currentCollection);
      
      var productsWithUnselectedSize = $products.filter(function(i, product) {
        var $product = $(product);
        var sizeSelectors = $product.find(selectors.sizeSelect);
        var selectedSize = $product.find(selectors.selectedSize);

        return sizeSelectors.length !== 0 && selectedSize.length === 0;
      });

      if (productsWithUnselectedSize.length === 0) {
        var variantIds = $('[data-variant-id]', $currentCollection).map(function(_, el) {
          return $(el).data('variant-id');
        });
        $addToCart.data('variant-id-list', variantIds.toArray());

        _enableAddToCart();
      } else {
        _disableAddToCart();
      }

      function _disableAddToCart() {
        $addToCart.prop('disabled', true);
        $addToCart.text(theme.strings.no_size_selected);
      }

      function _enableAddToCart() {
        $addToCart.prop('disabled', false);
        $addToCart.text(theme.strings.addToCart);
      }
    },

    _showLookForCollectionId: function(id) {
      var $lookboxes = $(selectors.lookboxCollection, this.$container);

      // Hide currently displayed lookbox
      $lookboxes.removeClass(classes.selectedLookbox)

      // Show selected lookbox
      $lookboxes.filter('[data-collection-id=' + id + ']').first().addClass(classes.selectedLookbox);
    }
  });

  return Lookbox;
})();


/*
 * Replaces the SVGs we had in the old website. This component is a floating
 * white dot that spawns a popup when clicked on and displays a product
 */
theme.FloatingProduct = (function() {
  function FloatingProduct(container) {
    this.$container = $(container)
    this._initSwatches()
  }

  var classes = {
    hidden: 'medium-up--hide'
  };

  var selectors = {
    floatingProductDot: '.floating-product-dot',
    product: '.floating-product-popup',
    productJson: '.product-json'
  };

  var settings = {
    mediaQueryMediumUp: 'screen and (min-width: 750px)',
    mediaQuerySmall: 'screen and (max-width: 749px)',
  };


  FloatingProduct.prototype = _.assignIn({}, FloatingProduct.prototype, {
    _getFloatingProducts() {
      floatingProducts = this.$container.find(selectors.floatingProductDot)
      return floatingProducts
    },

    _initSwatches: function() {
      var self = this;

      // Loop through products
      $(selectors.product, this.$container).each(function() {
        var $product = $(this);
        var json = $(selectors.productJson, $product);
        var product = JSON.parse(json.html());

        // create new variant for this product, enabling swatch image switch
        var options = {
          $container: $product,
          enableHistoryState: false,
          product: product,
          displaySwatches: true
        };

        var variants = new slate.Variants(options);

        $product.on('variantImageChange', function(evt) {
          self._updateProductImage(evt, $product);
        });
      });
    },

    _updateProductImage: function(evt, $productContainer) {
      var imageSelector = '[data-image-id=' + evt.image_id + ']';
      var $imageToShow = $(imageSelector, $productContainer);
      var $imagesToHide = $('[data-image-id]:not(' + imageSelector + ')', $productContainer);

      $imagesToHide.addClass(classes.hidden);
      $imageToShow.removeClass(classes.hidden);
    }
   })

  return FloatingProduct;
})();



function is_touch_device() {
  var prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
  var mq = function(query) {
    return window.matchMedia(query).matches;
  }

  if (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) {
    return true;
  }

  // include the 'heartz' as a way to have a non matching MQ to help terminate the join
  // https://git.io/vznFH
  var query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
  return mq(query);
}

$(document).ready(function() {
  var sections = new theme.Sections();

  sections.register('cart-template', theme.Cart);
  sections.register('image-slider', theme.ImageSlider);
  sections.register('product', theme.Product);
  sections.register('collection-template', theme.Collection);
  sections.register('collection-filters', theme.Filters);
  sections.register('ajax-cart', theme.AjaxCart); 
  sections.register('product-template', theme.Product);
  sections.register('header-section', theme.HeaderSection);
  sections.register('image-and-cta', theme.ImageAndCta);
  sections.register('map', theme.Maps);
  sections.register('carousel-section', theme.CarouselSection);
  sections.register('slideshow-section', theme.SlideshowSection);
  sections.register('quotes', theme.Quotes);
  sections.register('side-by-side', theme.SideBySide)
  sections.register('language-modal', theme.LanguageModalSection);
  sections.register('newsletter-modal', theme.NewsletterModalSection); 
  sections.register('lookbox', theme.LookboxSection); 
  sections.register('image-desktop-full-width', theme.FloatingProduct);
  //sections.register('image-desktop-full-width', theme.Product)

  _initModals();

  function _initModals() {
    $('.modal').each(function(index, modal) {
      // newsletter modal is shown on page load
      if (modal.id === 'NewsletterModal') {      
        return;
      }
      return new theme.Modals(modal.id, $(modal).data('modal'));
    });
  }

  var newsletterPopupCookie = readCookie('promotion-dismissed');
  if (newsletterPopupCookie == null | newsletterPopupCookie != 'true') {
    jQuery('.description-box.promotion').show();
  }

  $('#discount-explication-popover a.btn-remove').unbind().click(function(){
    $(this).parent().hide();
    createCookie('promotion-dismissed', 'true', 1/12);
  });
});

theme.init = function() {
  theme.customerTemplates.init();
  if (!is_touch_device()) {
    $('body').addClass('no-touch');
  }

  // Theme-specific selectors to make tables scrollable
  var tableSelectors = '.rte table,' + '.custom__item-inner--html table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'scrollable-wrapper'
  });

  // Theme-specific selectors to make iframes responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"],' +
    '.custom__item-inner--html iframe[src*="youtube.com/embed"],' +
    '.custom__item-inner--html iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'video-wrapper'
  });

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  $('a[href="#"]').on('click', function(evt) {
    evt.preventDefault();
  });

  slate.a11y.accessibleLinks({
    messages: {
      newWindow: theme.strings.newWindow,
      external: theme.strings.external,
      newWindowExternal: theme.strings.newWindowExternal
    },
    $links: $('a[href]:not([aria-describedby], .product-single__thumbnail)')
  });

  theme.FormStatus.init();
};

$(theme.init);

function createCookie(name,value,days) {
  if (days) {
      var date = new Date();
      date.setTime(date.getTime()+(days*24*60*60*1000));
      var expires = "; expires="+date.toGMTString();
  }
  else var expires = "";

  var cookie = name + "=" + value + expires
  document.cookie = cookie + "; domain=.vincentdamerique.com; path=/";
  document.cookie = cookie + "; path=/";
}

function readCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for(var i=0;i < ca.length;i++) {
      var c = ca[i];
      while (c.charAt(0)==' ') c = c.substring(1,c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
  }
  return null;
}
